import Header from "../common/Header";
import Sidebar from "../common/Sidebar";

export default function AepsNormalSettlement() {
  return (
    <>
      <Header />
      <div className="adminuiux-wrap">
        <Sidebar />
        <main
  className="adminuiux-content has-sidebar"
>
  {/*mt-4*/}
  <div className="container " id="main-content">
    <div className="row align-items-center">
      {/* <div class="col-6 col-sm-4 col-lg-3 col-xl-2 mb-4">
                  <div class="card adminuiux-card">
                      <div class="card-body">
                          <p class="text-secondary small mb-2">Total Profit</p>
                          <h4 class="mb-3">$13.20k</h4><span class="badge badge-light text-bg-success"><i class="me-1 bi bi-arrow-up-short"></i>28.50%</span></div>
                  </div>
              </div>
              <div class="col-6 col-sm-4 col-lg-3 col-xl-2 mb-4">
                  <div class="card adminuiux-card">
                      <div class="card-body">
                          <p class="text-secondary small mb-2">Best Profit</p>
                          <h4 class="mb-3">$8.34k</h4><span class="badge badge-light text-bg-success"><i class="me-1 bi bi-arrow-up-short"></i>54.35%</span></div>
                  </div>
              </div>
              <div class="col-12 col-sm-4 col-lg-3 col-xl-2 mb-4">
                  <div class="card adminuiux-card">
                      <div class="card-body">
                          <p class="text-secondary small mb-2">Top Loser</p>
                          <h4 class="mb-3">-$5.15k</h4><span class="badge badge-light text-bg-danger"><i class="me-1 bi bi-arrow-down-short"></i>18.25%</span></div>
                  </div>
              </div> */}
    </div>
    {/*<link
      href="https://kiaraapay.com/Aimra/css/select2.min.css"
      rel="stylesheet"
    /> */}
    
    <input type="hidden" defaultValue={8802072719} id="sender_number" />
    {/* dashboard inner */}
    <div className="midde_cont">
      <div className="container-fluid">
        <div className="row column_title">
          <div className="col-md-12">
            <div className="page_title d-sm-flex">
              <h2>Account Settlement</h2>
              <marquee width="80%" />
            </div>
          </div>
        </div>
        <div className="row match-height">
          <div className="col-md-12">
            <button
              onclick="service('1')"
              className="btn  btn-primary square mr-1 mb-1 waves-effect waves-light"
            >
              Aeps To Bank
            </button>
            <button
              onclick="service('2')"
              className="btn  btn-primary square mr-1 mb-1 waves-effect waves-light"
            >
              Aeps To Wallet
            </button>
          </div>
          <div className="col-md-5 col-12 mt-4">
            <div className="card adminuiux-card">
              <div className="card-header"></div>
              <div className="card-content">
                <div className="card-body">
                  <input
                    type="hidden"
                    name="_token"
                    defaultValue="EeQVcAQS1kOwAOoxuyPZzMH5LawYI8YUrTufMPg5"
                  />
                  {/*add beneficiary*/}
                  <div
                    className="form-body"
                    id="add-bene-box"
                    style={{ display: "none" }}
                  >
                    <div className="col-12">
                      <label htmlFor="contact-info-vertical">Bank</label>
                      <div className="form-group">
                        <select
                          className="form-control js-example-basic-single select2-hidden-accessible"
                          id="bank_name"
                          style={{ width: 385 }}
                          data-select2-id="select2-data-bank_name"
                          tabIndex={-1}
                          aria-hidden="true"
                        >
                          <option
                            value="A B BANK LIMITED"
                            data-select2-id="select2-data-2-57ob"
                          >
                            A B BANK LIMITED
                          </option>
                          <option value="ABHINANDAN URBAN CO-OP BANK LTD">
                            ABHINANDAN URBAN CO-OP BANK LTD
                          </option>
                          <option value="ABHINANDAN URBAN COOPERATIVE BANK LIMITED">
                            ABHINANDAN URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="ABHYUDAYA COOPERATIVE BANK LIMITED">
                            ABHYUDAYA COOPERATIVE BANK LIMITED
                          </option>
                          <option value="ABHYUDAYA MAHILA URBAN COOPERATIVE BANK LIMITED">
                            ABHYUDAYA MAHILA URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="ABN AMRO CREDIT CARD">
                            ABN AMRO CREDIT CARD
                          </option>
                          <option value="ABU DHABI COMMERCIAL BANK">
                            ABU DHABI COMMERCIAL BANK
                          </option>
                          <option value="ACBL ASHOKNAGAR COOPERATIVE BANK LIMITED">
                            ACBL ASHOKNAGAR COOPERATIVE BANK LIMITED
                          </option>
                          <option value="ACE COOPERATIVE BANK LIMITED">
                            ACE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="ADAR P.D.PATIL SAHAKARI BANK LIMITED ">
                            ADAR P.D.PATIL SAHAKARI BANK LIMITED{" "}
                          </option>
                          <option value="ADARSH COOPERATIVE BANK LIMITED">
                            ADARSH COOPERATIVE BANK LIMITED
                          </option>
                          <option value="ADARSH MAHILA NAGARI SAHAKARI BANK ">
                            ADARSH MAHILA NAGARI SAHAKARI BANK{" "}
                          </option>
                          <option value="ADITYA BIRLA IDEA PAYMENTS BANK">
                            ADITYA BIRLA IDEA PAYMENTS BANK
                          </option>
                          <option value="AHMEDABAD MERCANTILE COOPERATIVE BANK">
                            AHMEDABAD MERCANTILE COOPERATIVE BANK
                          </option>
                          <option value="AIRTEL PAYMENTS BANK LIMITED">
                            AIRTEL PAYMENTS BANK LIMITED
                          </option>
                          <option value="AJANTHA URBAN COOPERATIVE BANK ">
                            AJANTHA URBAN COOPERATIVE BANK{" "}
                          </option>
                          <option value="AKHAND ANAND COOPERATIVE BANK LIMITED">
                            AKHAND ANAND COOPERATIVE BANK LIMITED
                          </option>
                          <option value="AKOLA JANATA COMMERCIAL COOPERATIVE BANK">
                            AKOLA JANATA COMMERCIAL COOPERATIVE BANK
                          </option>
                          <option value="ALAPUZHA DISTRICT COOPERATIVE BANK">
                            ALAPUZHA DISTRICT COOPERATIVE BANK
                          </option>
                          <option value="ALIBAG COOPERATIVE URBAN BANK LIMITED ">
                            ALIBAG COOPERATIVE URBAN BANK LIMITED{" "}
                          </option>
                          <option value="ALLAHABAD UP GRAMIN BANK">
                            ALLAHABAD UP GRAMIN BANK
                          </option>
                          <option value="ALMORA URBAN COOPERATIVE BANK LIMITED">
                            ALMORA URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="ALMORA ZILA SAHAKARI BANK ">
                            ALMORA ZILA SAHAKARI BANK{" "}
                          </option>
                          <option value="AMAN SAHAKARI BANK LIMITED ">
                            AMAN SAHAKARI BANK LIMITED{" "}
                          </option>
                          <option value="AMBAJOGAI PEOPLES COOPERATIVE BANK LIMITED">
                            AMBAJOGAI PEOPLES COOPERATIVE BANK LIMITED
                          </option>
                          <option value="AMBARNATH JAI HIND COOPERATIVE BANK LIMITED">
                            AMBARNATH JAI HIND COOPERATIVE BANK LIMITED
                          </option>
                          <option value="AMERICAN EXPRESS CREDIT CARD">
                            AMERICAN EXPRESS CREDIT CARD
                          </option>
                          <option value="AMRAVATI DCC BANK ">
                            AMRAVATI DCC BANK{" "}
                          </option>
                          <option value="AMRELI JILLA SAHAKARI BANK LIMITED">
                            AMRELI JILLA SAHAKARI BANK LIMITED
                          </option>
                          <option value="AMRELI NAGRIK SAHAKARI BANK LIMITED">
                            AMRELI NAGRIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="ANDAMAN & NICOBAR STATE COOPERATIVE BANK LIMITED">
                            ANDAMAN &amp; NICOBAR STATE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="ANDHRA BANK">ANDHRA BANK</option>
                          <option value="ANDHRA PRADESH GRAMIN VIKAS BANK">
                            ANDHRA PRADESH GRAMIN VIKAS BANK
                          </option>
                          <option value="ANDHRA PRAGATHI GRAMIN BANK">
                            ANDHRA PRAGATHI GRAMIN BANK
                          </option>
                          <option value="ANGUL CENTRAL COOPERATIVE BANK">
                            ANGUL CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="ANNASAHEB CHOUGULE COOPERATIVE URBAN BANK">
                            ANNASAHEB CHOUGULE COOPERATIVE URBAN BANK
                          </option>
                          <option value="AP MAHESH COOPERATIVE URBAN BANK LIMITED">
                            AP MAHESH COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="AP RAJA MAHESHWARI BANK">
                            AP RAJA MAHESHWARI BANK
                          </option>
                          <option value="APNA SAHAKARI BANK LIMITED">
                            APNA SAHAKARI BANK LIMITED
                          </option>
                          <option value="ARIHANT URBAN COOPERATIVE BANK LIMITED, HDFC BANK">
                            ARIHANT URBAN COOPERATIVE BANK LIMITED, HDFC BANK
                          </option>
                          <option value="ARUNACHAL PRADESH RURAL BANK">
                            ARUNACHAL PRADESH RURAL BANK
                          </option>
                          <option value="ARYA VART GRAMIN BANK">
                            ARYA VART GRAMIN BANK
                          </option>
                          <option value="ASHOK SAHAKARI BANK LIMITED">
                            ASHOK SAHAKARI BANK LIMITED
                          </option>
                          <option value="ASSAM GRAMIN VIKASH BANK">
                            ASSAM GRAMIN VIKASH BANK
                          </option>
                          <option value="ASSOCIATE COOPERATIVE BANK">
                            ASSOCIATE COOPERATIVE BANK
                          </option>
                          <option value="AU SMALL FINANCE BANK LIMITED">
                            AU SMALL FINANCE BANK LIMITED
                          </option>
                          <option value="AURANGABAD DCC BANK">
                            AURANGABAD DCC BANK
                          </option>
                          <option value="AURANGABAD DCC BANK HO">
                            AURANGABAD DCC BANK HO
                          </option>
                          <option value="AURANGABAD DIST CENTRAL COOPERATIVE BANK">
                            AURANGABAD DIST CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED">
                            AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED
                          </option>
                          <option value="AXIS BANK">AXIS BANK</option>
                          <option value="AXIS BANK CREDIT CARD">
                            AXIS BANK CREDIT CARD
                          </option>
                          <option value="BALAGERIA CENTRAL COOPERATIVE BANK LIMITED">
                            BALAGERIA CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="BALASORE COOPERATIVE URBAN BANK LIMITED">
                            BALASORE COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="BALIA ETAWA GRAMIN BANK">
                            BALIA ETAWA GRAMIN BANK
                          </option>
                          <option value="BALLY COOPERATIVE BANK LIMITED">
                            BALLY COOPERATIVE BANK LIMITED
                          </option>
                          <option value="BALOTRA URBAN COOPERATIVE BANK LIMITED">
                            BALOTRA URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="BANASKANTHA DISTRICT CENTRAL COOPERATIVE BANK LIMI">
                            BANASKANTHA DISTRICT CENTRAL COOPERATIVE BANK LIMI
                          </option>
                          <option value="BANASKANTHA MERCANTILE COOPERATIVE BANK LIMITED">
                            BANASKANTHA MERCANTILE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="banda district co-operative bank ltd">
                            banda district co-operative bank ltd
                          </option>
                          <option value="BANDA URBAN COOPERATIVE BANK ">
                            BANDA URBAN COOPERATIVE BANK{" "}
                          </option>
                          <option value="BANDHAN BANK LIMITED">
                            BANDHAN BANK LIMITED
                          </option>
                          <option value="BANGIYA GRAMIN VIKASH BANK">
                            BANGIYA GRAMIN VIKASH BANK
                          </option>
                          <option value="BANK OF AMERICA">
                            BANK OF AMERICA
                          </option>
                          <option value="BANK OF BARODA">BANK OF BARODA</option>
                          <option value="BANK OF BARODA CREDIT CARD">
                            BANK OF BARODA CREDIT CARD
                          </option>
                          <option value="BANK OF CEYLON">BANK OF CEYLON</option>
                          <option value="BANK OF INDIA">BANK OF INDIA</option>
                          <option value="BANK OF MAHARASHTRA">
                            BANK OF MAHARASHTRA
                          </option>
                          <option value="BANK OF TOKYO MITSUBISHI LIMITED">
                            BANK OF TOKYO MITSUBISHI LIMITED
                          </option>
                          <option value="BAPUJI COOPERATIVE BANK LIMITED">
                            BAPUJI COOPERATIVE BANK LIMITED
                          </option>
                          <option value="BARCLAYS BANK">BARCLAYS BANK</option>
                          <option value="BARCLAYS BANK CREDIT CARD">
                            BARCLAYS BANK CREDIT CARD
                          </option>
                          <option value="BARODA CENTRAL COOPERATIVE BANK LIMITED">
                            BARODA CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="BARODA GUJARAT GRAMIN BANK">
                            BARODA GUJARAT GRAMIN BANK
                          </option>
                          <option value="BARODA RAJASTHAN GRAMIN BANK">
                            BARODA RAJASTHAN GRAMIN BANK
                          </option>
                          <option value="BARODA UTTAR PRADESH GRAMIN BANK">
                            BARODA UTTAR PRADESH GRAMIN BANK
                          </option>
                          <option value="BASSEIN CATHOLIC COOPERATIVE BANK LIMITED">
                            BASSEIN CATHOLIC COOPERATIVE BANK LIMITED
                          </option>
                          <option value="BELAGAVI SHREE BASAVESHWAR COOPERATIVE BANK">
                            BELAGAVI SHREE BASAVESHWAR COOPERATIVE BANK
                          </option>
                          <option value="BELLAD BAGEWADI URBAN SOUHARD SAHAKARI BANK ">
                            BELLAD BAGEWADI URBAN SOUHARD SAHAKARI BANK{" "}
                          </option>
                          <option value="BHADOHI URBAN COOPERATIVE BANK">
                            BHADOHI URBAN COOPERATIVE BANK
                          </option>
                          <option value="BHADRADRI COOPERATIVE URBAN BANK LIMITED ">
                            BHADRADRI COOPERATIVE URBAN BANK LIMITED{" "}
                          </option>
                          <option value="BHAGINI NIVEDITA SAHAKARI BANK LIMITED">
                            BHAGINI NIVEDITA SAHAKARI BANK LIMITED
                          </option>
                          <option value="BHAGYODAYA FRIENDS UR COOPERATIVE BANK LIMITED">
                            BHAGYODAYA FRIENDS UR COOPERATIVE BANK LIMITED
                          </option>
                          <option value="BHARAT COOPERATIVE BANK MUMBAI LIMITED">
                            BHARAT COOPERATIVE BANK MUMBAI LIMITED
                          </option>
                          <option value="BHARUCH DISTRICT CENTRAL COOPERATIVE BANK LIMITED">
                            BHARUCH DISTRICT CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="BHATPARA NAIHATI COOPERATIVE BANK LIMITED ">
                            BHATPARA NAIHATI COOPERATIVE BANK LIMITED{" "}
                          </option>
                          <option value="BHAVANA RISHI COOPERATIVE BANK ">
                            BHAVANA RISHI COOPERATIVE BANK{" "}
                          </option>
                          <option value="BHAVNAGAR DISTRICT CENTRAL COOPERATIVE BANK LIMITE">
                            BHAVNAGAR DISTRICT CENTRAL COOPERATIVE BANK LIMITE
                          </option>
                          <option value="BHILWARA URBAN COOPERATIVE BANK LIMITED">
                            BHILWARA URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="BHIND NAGRIK SAHAKARI BANK ">
                            BHIND NAGRIK SAHAKARI BANK{" "}
                          </option>
                          <option value="BHOPAL  COOPERATIVE CENTRAL BANK LIMITED">
                            BHOPAL COOPERATIVE CENTRAL BANK LIMITED
                          </option>
                          <option value="BHUJ MERCHANTILE BANK">
                            BHUJ MERCHANTILE BANK
                          </option>
                          <option value="BIHAR GRAMIN BANK">
                            BIHAR GRAMIN BANK
                          </option>
                          <option value="BIHAR STATE COOPERATIVE BANK ">
                            BIHAR STATE COOPERATIVE BANK{" "}
                          </option>
                          <option value="BNP PARIBAS BANK">
                            BNP PARIBAS BANK
                          </option>
                          <option value="BOLANGIR CENTRAL COOPERATIVE BANK LIMITED">
                            BOLANGIR CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="BOMBAY MERCANTILE COOPERATIVE BANK LIMITED">
                            BOMBAY MERCANTILE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="BOUDH COOPERATIVE CENTRAL BANK ">
                            BOUDH COOPERATIVE CENTRAL BANK{" "}
                          </option>
                          <option value="CANARA BANK">CANARA BANK</option>
                          <option value="CANARA BANK CREDIT CARD">
                            CANARA BANK CREDIT CARD
                          </option>
                          <option value="CAPITAL SMALL FINANCE BANK LIMITED">
                            CAPITAL SMALL FINANCE BANK LIMITED
                          </option>
                          <option value="CATHOLIC SYRIAN BANK LIMITED">
                            CATHOLIC SYRIAN BANK LIMITED
                          </option>
                          <option value="CENTRAL BANK OF INDIA">
                            CENTRAL BANK OF INDIA
                          </option>
                          <option value="CENTRAL COOPERATIVE BANK LIMITED">
                            CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="CHAITANYA GODAVARI GRAMIN BANK">
                            CHAITANYA GODAVARI GRAMIN BANK
                          </option>
                          <option value="CHAMOLI ZILA SAHAKARI BANK LIMITED">
                            CHAMOLI ZILA SAHAKARI BANK LIMITED
                          </option>
                          <option value="CHARTERED SAHAKARI BANK NIYAMITHA">
                            CHARTERED SAHAKARI BANK NIYAMITHA
                          </option>
                          <option value="CHEMBUR NAGARIK SAHAKARI BANK">
                            CHEMBUR NAGARIK SAHAKARI BANK
                          </option>
                          <option value="CHHATTISGARH GRAMIN BANK">
                            CHHATTISGARH GRAMIN BANK
                          </option>
                          <option value="CHIKHLI URBAN COOPERATIVE BANK ">
                            CHIKHLI URBAN COOPERATIVE BANK{" "}
                          </option>
                          <option value="CHITTORGARH CENTRAL COOPERATIVE BANK LIMITED">
                            CHITTORGARH CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="CHITTORGARH URBAN COOPERATIVE BANK LIMITED">
                            CHITTORGARH URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="CITI BANK">CITI BANK</option>
                          <option value="CITIBANK CREDIT CARD">
                            CITIBANK CREDIT CARD
                          </option>
                          <option value="CITIZEN COOPERATIVE BANK LIMITED">
                            CITIZEN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="CITIZEN CREDIT COOPERATIVE BANK LIMITED">
                            CITIZEN CREDIT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="CITIZENS COOPERATIVE BANK LIMITED">
                            CITIZENS COOPERATIVE BANK LIMITED
                          </option>
                          <option value="CITY UNION BANK LIMITED">
                            CITY UNION BANK LIMITED
                          </option>
                          <option value="COMMONWEALTH BANK OF AUSTRALIA">
                            COMMONWEALTH BANK OF AUSTRALIA
                          </option>
                          <option value="CORPORATION BANK">
                            CORPORATION BANK
                          </option>
                          <option value="CORPORATION BANK CREDIT CARD">
                            CORPORATION BANK CREDIT CARD
                          </option>
                          <option value="CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK CALYON BANK">
                            CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK CALYON
                            BANK
                          </option>
                          <option value="CUTTACK CENTRAL COOPERATIVE BANK">
                            CUTTACK CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="DAKSHIN BIHAR GRAMIN BANK">
                            DAKSHIN BIHAR GRAMIN BANK
                          </option>
                          <option value="DAPOLI URBAN COOPERATIVE BANK LIMITED">
                            DAPOLI URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="DARUSSALAM COOPERATIVE URBAN BANK LIMITED">
                            DARUSSALAM COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="DATTATRAYA MAHARAJ KALAMBE JAOLI SAHAKARI BANK LIM">
                            DATTATRAYA MAHARAJ KALAMBE JAOLI SAHAKARI BANK LIM
                          </option>
                          <option value="DBS">DBS</option>
                          <option value="DCB BANK LIMITED">
                            DCB BANK LIMITED
                          </option>
                          <option value="DEENDAYAL N S BANK LIMITED">
                            DEENDAYAL N S BANK LIMITED
                          </option>
                          <option value="DEENDAYAL NAGARI SAHAKARI BANK LIMITED">
                            DEENDAYAL NAGARI SAHAKARI BANK LIMITED
                          </option>
                          <option value="DEHRADUN DISTT COOPERATIVE BANK ">
                            DEHRADUN DISTT COOPERATIVE BANK{" "}
                          </option>
                          <option value="DELHI NAGRIK SEH BANK">
                            DELHI NAGRIK SEH BANK
                          </option>
                          <option value="DENA GUJARAT GRAMIN BANK">
                            DENA GUJARAT GRAMIN BANK
                          </option>
                          <option value="DENA GUJARAT GRAMIN BANK">
                            DENA GUJARAT GRAMIN BANK
                          </option>
                          <option value="DEOGIRI NAGARI SAHAKARI BANK LIMITED">
                            DEOGIRI NAGARI SAHAKARI BANK LIMITED
                          </option>
                          <option value="DEUSTCHE BANK">DEUSTCHE BANK</option>
                          <option value="DEVELOPMENT BANK OF SINGAPORE">
                            DEVELOPMENT BANK OF SINGAPORE
                          </option>
                          <option value="DHANALAKSHMI BANK">
                            DHANALAKSHMI BANK
                          </option>
                          <option value="District Co Operative Bank Ltd Faizabad">
                            District Co Operative Bank Ltd Faizabad
                          </option>
                          <option value="DISTRICT COOPERATIVE BANK">
                            DISTRICT COOPERATIVE BANK
                          </option>
                          <option value="DISTRICT COOPERATIVE BANK LIMITED ">
                            DISTRICT COOPERATIVE BANK LIMITED{" "}
                          </option>
                          <option value="District Cooperative Bank limited">
                            District Cooperative Bank limited
                          </option>
                          <option value="DOHA BANK">DOHA BANK</option>
                          <option value="DOHA BANK ">DOHA BANK </option>
                          <option value="DOMBIVLI NAGARI SAHAKARI BANK LIMITED">
                            DOMBIVLI NAGARI SAHAKARI BANK LIMITED
                          </option>
                          <option value="DR JAIPRAKASH MUNDADA URBAN COOPERATIVE BANK">
                            DR JAIPRAKASH MUNDADA URBAN COOPERATIVE BANK
                          </option>
                          <option value="DUMKA CENTRAL COOPERATIVE  BANK LIMITED">
                            DUMKA CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="ELLAQUAI DEHATI BANK">
                            ELLAQUAI DEHATI BANK
                          </option>
                          <option value="EQUITAS SMALL FINANCE BANK LIMITED">
                            EQUITAS SMALL FINANCE BANK LIMITED
                          </option>
                          <option value="ESAF SMALL FINANCE BANK LIMITED">
                            ESAF SMALL FINANCE BANK LIMITED
                          </option>
                          <option value="ETAH DISTRICT COOPERATIVE BANK LIMITED">
                            ETAH DISTRICT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="ETAH URBAN COOPERATIVE BANK LIMITED">
                            ETAH URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="ETAWAH DISTRICT COOPERATIVE BANK LIMITED">
                            ETAWAH DISTRICT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="EXPORT IMPORT BANK OF INDIA">
                            EXPORT IMPORT BANK OF INDIA
                          </option>
                          <option value="FEDERAL BANK">FEDERAL BANK</option>
                          <option value="FINANCIAL COOPERATIVE BANK ">
                            FINANCIAL COOPERATIVE BANK{" "}
                          </option>
                          <option value="FINCARE SMALL FINANCE BANK LIMITED">
                            FINCARE SMALL FINANCE BANK LIMITED
                          </option>
                          <option value="Fingrowth Cooperative Bank Ltd">
                            Fingrowth Cooperative Bank Ltd
                          </option>
                          <option value="FINO PAYMENTS BANK LIMITED">
                            FINO PAYMENTS BANK LIMITED
                          </option>
                          <option value="FIRSTRAND BANK LIMITED">
                            FIRSTRAND BANK LIMITED
                          </option>
                          <option value="GANDHINAGAR NAG. COOPERATIVE BANK LIMITED">
                            GANDHINAGAR NAG. COOPERATIVE BANK LIMITED
                          </option>
                          <option value="GODAVARI URBAN COOPERATIVE BANK ">
                            GODAVARI URBAN COOPERATIVE BANK{" "}
                          </option>
                          <option value="GODHRA URBAN COOPERATIVE BANK LIMITED">
                            GODHRA URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="GOPINATH PATIL PARSIK BANK">
                            GOPINATH PATIL PARSIK BANK
                          </option>
                          <option value="GURGAON GRAMIN BANK">
                            GURGAON GRAMIN BANK
                          </option>
                          <option value="HAMIRPUR DISTRICT COOPERATIVE BANK LIMITED">
                            HAMIRPUR DISTRICT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="HANAMASAGAR URBAN COOPERATIVE BANK">
                            HANAMASAGAR URBAN COOPERATIVE BANK
                          </option>
                          <option value="HAVELI SAHAKARI BANK ">
                            HAVELI SAHAKARI BANK{" "}
                          </option>
                          <option value="HDFC BANK">HDFC BANK</option>
                          <option value="HDFC BANK LTD CREDIT CARD">
                            HDFC BANK LTD CREDIT CARD
                          </option>
                          <option value="HIMACHAL GRAMIN BANK">
                            HIMACHAL GRAMIN BANK
                          </option>
                          <option value="HIMACHAL PRADESH STATE COOPERATIVE BANK LIMITED">
                            HIMACHAL PRADESH STATE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="HIMATNAGAR NAGARIK SAHAKARI BANK">
                            HIMATNAGAR NAGARIK SAHAKARI BANK
                          </option>
                          <option value="HSBC BANK">HSBC BANK</option>
                          <option value="HSBC CREDIT CARD">
                            HSBC CREDIT CARD
                          </option>
                          <option value="HUTATMA SAHAKARI BANK LIMITED">
                            HUTATMA SAHAKARI BANK LIMITED
                          </option>
                          <option value="HUTATMA SHAHKARI BANK LIMITED ">
                            HUTATMA SHAHKARI BANK LIMITED{" "}
                          </option>
                          <option value="ICICI BANK LIMITED">
                            ICICI BANK LIMITED
                          </option>
                          <option value="ICICI BANK LTD CREDIT CARD">
                            ICICI BANK LTD CREDIT CARD
                          </option>
                          <option value="IDBI BANK">IDBI BANK</option>
                          <option value="IDBI BANK LIMITED,MHAISAL">
                            IDBI BANK LIMITED,MHAISAL
                          </option>
                          <option value="IDFC BANK LIMITED">
                            IDFC BANK LIMITED
                          </option>
                          <option value="IDUKKI DISTRICT COOPERATIVE BANK LIMITED">
                            IDUKKI DISTRICT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="ILKAL COOPERATIVE BANK LIMITED">
                            ILKAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="INDIA POST PAYMENT BANK">
                            INDIA POST PAYMENT BANK
                          </option>
                          <option value="INDIAN BANK">INDIAN BANK</option>
                          <option value="INDIAN OVERSEAS BANK">
                            INDIAN OVERSEAS BANK
                          </option>
                          <option value="INDIAN OVERSEAS BANK CREDIT CARD">
                            INDIAN OVERSEAS BANK CREDIT CARD
                          </option>
                          <option value="INDIRA  MAHILA  SAHAKARI BANK LIMITED">
                            INDIRA MAHILA SAHAKARI BANK LIMITED
                          </option>
                          <option value="INDRAYANI COOPERATIVE  BANK LIMITED">
                            INDRAYANI COOPERATIVE BANK LIMITED
                          </option>
                          <option value="INDUSIND BANK">INDUSIND BANK</option>
                          <option value="IndusInd Bank CREDIT CARD">
                            IndusInd Bank CREDIT CARD
                          </option>
                          <option value="INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED">
                            INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED
                          </option>
                          <option value="INDUSTRIAL BANK OF KOREA">
                            INDUSTRIAL BANK OF KOREA
                          </option>
                          <option value="ING VYSYA BANK LTD">
                            ING VYSYA BANK LTD
                          </option>
                          <option value="INTEGRAL URBAN COOPERATIVE BANK LIMITED">
                            INTEGRAL URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="IOB PANDYAN GRAMA BANK">
                            IOB PANDYAN GRAMA BANK
                          </option>
                          <option value="IRINJALAKUDA TOWN COOPERATIVE BANK LIMITED">
                            IRINJALAKUDA TOWN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="JALGAON JANATA SAHAKARI BANK LIMITED">
                            JALGAON JANATA SAHAKARI BANK LIMITED
                          </option>
                          <option value="JALNA DIST CENTRAL COOPERATIVE BANK LIMITED">
                            JALNA DIST CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="JALNA MERCHANTS COOPERATIVE BANK LIMITED ">
                            JALNA MERCHANTS COOPERATIVE BANK LIMITED{" "}
                          </option>
                          <option value="JALORE NAGRIK SAHAKARI BANK LIMITED">
                            JALORE NAGRIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="JAMIA COOPERATIVE BANK LIMITED">
                            JAMIA COOPERATIVE BANK LIMITED
                          </option>
                          <option value="JAMMU AND KASHMIR BANK LIMITED">
                            JAMMU AND KASHMIR BANK LIMITED
                          </option>
                          <option value="JAMMU AND KASHMIR GRAMEEN BANK">
                            JAMMU AND KASHMIR GRAMEEN BANK
                          </option>
                          <option value="JAMPETA COOPERATIVE URBAN BANK LIMITED">
                            JAMPETA COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="JANA SMALL FINANCE BANK LTD">
                            JANA SMALL FINANCE BANK LTD
                          </option>
                          <option value="JANAKALYAN SAHAKARI BANK LIMITED">
                            JANAKALYAN SAHAKARI BANK LIMITED
                          </option>
                          <option value="JANASEVA SAHAKARI BANK BORIVLI LIMITED">
                            JANASEVA SAHAKARI BANK BORIVLI LIMITED
                          </option>
                          <option value="JANASEVA SAHAKARI BANK LIMITED">
                            JANASEVA SAHAKARI BANK LIMITED
                          </option>
                          <option value="JANATA COOPERATIVE BANK LIMITED, MALEGAON">
                            JANATA COOPERATIVE BANK LIMITED, MALEGAON
                          </option>
                          <option value="JANATA SAHAKARI BANK LIMITED">
                            JANATA SAHAKARI BANK LIMITED
                          </option>
                          <option value="JANTA SAHAKARI BANK LIMITED">
                            JANTA SAHAKARI BANK LIMITED
                          </option>
                          <option value="JAWAHAR SAHAKARI BANK LIMITED ">
                            JAWAHAR SAHAKARI BANK LIMITED{" "}
                          </option>
                          <option value="JAYSINGPUR UDGAON SAHAKARI BANK LIMITED">
                            JAYSINGPUR UDGAON SAHAKARI BANK LIMITED
                          </option>
                          <option value="JHARKHAND GRAMIN BANK">
                            JHARKHAND GRAMIN BANK
                          </option>
                          <option value="JIJAMATA MAHILA SAHAKARI BANK LIMITED ">
                            JIJAMATA MAHILA SAHAKARI BANK LIMITED{" "}
                          </option>
                          <option value="JILA SAHAKARI KENDRIYA BANK ">
                            JILA SAHAKARI KENDRIYA BANK{" "}
                          </option>
                          <option value="JILA SAHAKARI KENDRIYA BANK">
                            JILA SAHAKARI KENDRIYA BANK
                          </option>
                          <option value="JIVAN COMMERCIAL COOPERATIVE BANK LIMITED">
                            JIVAN COMMERCIAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="JODHPUR NAGRIK SAHAKARI BANK LIMITED">
                            JODHPUR NAGRIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="JP MORGAN BANK">JP MORGAN BANK</option>
                          <option value="KAIRA DISTRICT CENTRAL COOPERATIVE BANK">
                            KAIRA DISTRICT CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="KALLAPPANNA AWADE ICHALKARANJI JANATA SAHAKARI BAN">
                            KALLAPPANNA AWADE ICHALKARANJI JANATA SAHAKARI BAN
                          </option>
                          <option value="KALUPUR COMMERCIAL COOPERATIVE BANK">
                            KALUPUR COMMERCIAL COOPERATIVE BANK
                          </option>
                          <option value="KALYAN JANATA SAHAKARI BANK">
                            KALYAN JANATA SAHAKARI BANK
                          </option>
                          <option value="KANARA DISTRICT CENTRAL COOPERATIVE BANK">
                            KANARA DISTRICT CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="KANKARIA MANINAGAR COOPERATIVE BANK LIMITED">
                            KANKARIA MANINAGAR COOPERATIVE BANK LIMITED
                          </option>
                          <option value="KANPUR ZILLA SAHAKARI BANK LIMITED">
                            KANPUR ZILLA SAHAKARI BANK LIMITED
                          </option>
                          <option value="KARNALA NAGARI SAHAKARI BANK">
                            KARNALA NAGARI SAHAKARI BANK
                          </option>
                          <option value="KARNATAKA BANK LIMITED">
                            KARNATAKA BANK LIMITED
                          </option>
                          <option value="KARNATAKA VIKAS GRAMIN BANK">
                            KARNATAKA VIKAS GRAMIN BANK
                          </option>
                          <option value="KARUR VYSYA BANK">
                            KARUR VYSYA BANK
                          </option>
                          <option value="KASHMIR MERCANTILE COOPERATIVE BANK LIMITED">
                            KASHMIR MERCANTILE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="Kaveri Grameena Bank">
                            Kaveri Grameena Bank
                          </option>
                          <option value="KAVERI KALPATARU GRAMIN BANK">
                            KAVERI KALPATARU GRAMIN BANK
                          </option>
                          <option value="KEB Hana Bank">KEB Hana Bank</option>
                          <option value="KEONJHAR CENTRAL COOOPERATIVE BANK">
                            KEONJHAR CENTRAL COOOPERATIVE BANK
                          </option>
                          <option value="KERALA GRAMIN BANK">
                            KERALA GRAMIN BANK
                          </option>
                          <option value="KHALILABAD NAGAR SAHAKARI BANK LIMITED ICICI BANK">
                            KHALILABAD NAGAR SAHAKARI BANK LIMITED ICICI BANK
                          </option>
                          <option value="KHALILABAD NAGAR SAHAKARI BANK YES BANK">
                            KHALILABAD NAGAR SAHAKARI BANK YES BANK
                          </option>
                          <option value="KHAMGAON URBAN COOPERATIVE BANK LIMITED">
                            KHAMGAON URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="KHATTRI COOPERATIVE URBAN BANK ">
                            KHATTRI COOPERATIVE URBAN BANK{" "}
                          </option>
                          <option value="KHORDA CENTRAL COOPERATIVE BANK ">
                            KHORDA CENTRAL COOPERATIVE BANK{" "}
                          </option>
                          <option value="KHORDHA CENTRAL COOPERATIVE BANK">
                            KHORDHA CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="KOKAN MERCANTILE COOPERATIVE BANK LIMITED ">
                            KOKAN MERCANTILE COOPERATIVE BANK LIMITED{" "}
                          </option>
                          <option value="KOLHAPUR DISTRICT CENTRAL COOPERATIVE BANK LIMITED">
                            KOLHAPUR DISTRICT CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="KOLHAPUR MAHILA SAHAKARI BANK LIMITED">
                            KOLHAPUR MAHILA SAHAKARI BANK LIMITED
                          </option>
                          <option value="KOTA NAGRIK SAHAKARI BANK LIMITED">
                            KOTA NAGRIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="KOTAK MAHINDRA BANK CREDIT CARD">
                            KOTAK MAHINDRA BANK CREDIT CARD
                          </option>
                          <option value="KOTAK MAHINDRA BANK LIMITED">
                            KOTAK MAHINDRA BANK LIMITED
                          </option>
                          <option value="KOTTAYAM COOPERATIVE URBAN BANK LIMITED">
                            KOTTAYAM COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="KOZHIKODE DISTRICT COOPERATIAVE BANK LIMITED">
                            KOZHIKODE DISTRICT COOPERATIAVE BANK LIMITED
                          </option>
                          <option value="KRISHNA GRAMEENA BANK">
                            KRISHNA GRAMEENA BANK
                          </option>
                          <option value="KURLA N S BANK ">
                            KURLA N S BANK{" "}
                          </option>
                          <option value="LAKHIMPUR URBAN COOPERATIVE BANK LIMITED">
                            LAKHIMPUR URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="Lakshmi Vilas bank">
                            Lakshmi Vilas bank
                          </option>
                          <option value="LANGPI DEHANGI RURAL BANK">
                            LANGPI DEHANGI RURAL BANK
                          </option>
                          <option value="LATUR DISTRICT CENTRAL COOPERATIVE BANK LIMITED">
                            LATUR DISTRICT CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="LAXMI VILAS BANK">
                            LAXMI VILAS BANK
                          </option>
                          <option value="LOKMANGAL COOPERATIVE BANK LIMITED">
                            LOKMANGAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="LONAVALA SAHAKARI BANK LIMITED">
                            LONAVALA SAHAKARI BANK LIMITED
                          </option>
                          <option value="M S COOPERATIVE BANK LIMITED">
                            M S COOPERATIVE BANK LIMITED
                          </option>
                          <option value="M.P. RAJYA SAHAKARI BANK ">
                            M.P. RAJYA SAHAKARI BANK{" "}
                          </option>
                          <option value="MADHYA BHARAT GRAMIN BANK">
                            MADHYA BHARAT GRAMIN BANK
                          </option>
                          <option value="MADHYA BIHAR GRAMIN BANK">
                            MADHYA BIHAR GRAMIN BANK
                          </option>
                          <option value="MAGADH CENTRAL COOPERATIVE BANK LIMITED">
                            MAGADH CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="MAHANAGAR CO-OP BANK LTD">
                            MAHANAGAR CO-OP BANK LTD
                          </option>
                          <option value="MAHANAGAR COOPERATIVE BANK">
                            MAHANAGAR COOPERATIVE BANK
                          </option>
                          <option value="MAHARASHTRA GRAMIN BANK">
                            MAHARASHTRA GRAMIN BANK
                          </option>
                          <option value="MAHARASHTRA STATE COOPERATIVE BANK">
                            MAHARASHTRA STATE COOPERATIVE BANK
                          </option>
                          <option value="MAHAVEER COOPERATIVE URBAN BANK LIMITED">
                            MAHAVEER COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="MAHESH SAHAKARI BANK ">
                            MAHESH SAHAKARI BANK{" "}
                          </option>
                          <option value="MAHESH SAHAKARI BANK LIMITED">
                            MAHESH SAHAKARI BANK LIMITED
                          </option>
                          <option value="MAHILA SAMRIDHI BANK ">
                            MAHILA SAMRIDHI BANK{" "}
                          </option>
                          <option value="MALAD SAHAKARI BANK LIMITED">
                            MALAD SAHAKARI BANK LIMITED
                          </option>
                          <option value="MALVIYA URBAN COOPERATIVE BANK LIMITED">
                            MALVIYA URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="MALWA GRAMIN BANK">
                            MALWA GRAMIN BANK
                          </option>
                          <option value="MANIPUR RURAL BANK">
                            MANIPUR RURAL BANK
                          </option>
                          <option value="MANIPUR RURAL BANK">
                            MANIPUR RURAL BANK
                          </option>
                          <option value="MANJERI COOPERATIVE URBAN BANK LIMITED">
                            MANJERI COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="MANNDESHI MAHILA SAHAKARI BANK LIMITED">
                            MANNDESHI MAHILA SAHAKARI BANK LIMITED
                          </option>
                          <option value="MANORAMA COOPERATIVE.BANK LIMITED">
                            MANORAMA COOPERATIVE.BANK LIMITED
                          </option>
                          <option value="MANSING COOPERATIVE BANK LIMITED">
                            MANSING COOPERATIVE BANK LIMITED
                          </option>
                          <option value="MARATHA COOPERATIVE BANK LIMITED">
                            MARATHA COOPERATIVE BANK LIMITED
                          </option>
                          <option value="MASHREQ BANK">MASHREQ BANK</option>
                          <option value="MATHURA ZILLA SAHAKARI BANK LIMITED">
                            MATHURA ZILLA SAHAKARI BANK LIMITED
                          </option>
                          <option value="MAYURBHANJ CENTRAL COOPERATIVE BANK LIMITED">
                            MAYURBHANJ CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="MEGHALAYA COOPERATIVE APEX BANK ">
                            MEGHALAYA COOPERATIVE APEX BANK{" "}
                          </option>
                          <option value="MEGHALAYA RURAL BANK">
                            MEGHALAYA RURAL BANK
                          </option>
                          <option value="MEHSANA DISTRICT CENTRAL COOPERATIVE BANK LIMITED">
                            MEHSANA DISTRICT CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="MEWAR AANCHALIK GRAMIN BANK">
                            MEWAR AANCHALIK GRAMIN BANK
                          </option>
                          <option value="MIZORAM COOPERATIVE APEX BANK LIMITED">
                            MIZORAM COOPERATIVE APEX BANK LIMITED
                          </option>
                          <option value="MIZORAM RURAL BANK">
                            MIZORAM RURAL BANK
                          </option>
                          <option value="MIZUHO BANK LIMITED">
                            MIZUHO BANK LIMITED
                          </option>
                          <option value="MODEL COOPERATIVE BANK LIMITED">
                            MODEL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="MOGAVEERA COOPERATIVE BANK">
                            MOGAVEERA COOPERATIVE BANK
                          </option>
                          <option value="MUDGAL URBAN COOPERATIVE BANK LIMITED">
                            MUDGAL URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="MURSHIDABAD DIST CENTRAL COOPERATIVE BANK">
                            MURSHIDABAD DIST CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="MUZAFFARPUR CENTRAL COOPERATIVE BANK">
                            MUZAFFARPUR CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="NAGALAND RURAL BANK">
                            NAGALAND RURAL BANK
                          </option>
                          <option value="NAGAR SAHAKARI BANK LIMITED">
                            NAGAR SAHAKARI BANK LIMITED
                          </option>
                          <option value="NAGAR SAHAKARI BANK, YES BANK">
                            NAGAR SAHAKARI BANK, YES BANK
                          </option>
                          <option value="NAGAR URBAN CO OPERATIVE BANK">
                            NAGAR URBAN CO OPERATIVE BANK
                          </option>
                          <option value="NAGAR URBAN COOPERATIVE BANK">
                            NAGAR URBAN COOPERATIVE BANK
                          </option>
                          <option value="NAGAR VIKAS SAHAKARI BANK ">
                            NAGAR VIKAS SAHAKARI BANK{" "}
                          </option>
                          <option value="NAGPUR NAGARIK SAHAKARI BANK LIMITED">
                            NAGPUR NAGARIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="NAINITAL ALMORA KSHETRIYA GRAMIN BANK">
                            NAINITAL ALMORA KSHETRIYA GRAMIN BANK
                          </option>
                          <option value="Nainital District Cooperative Bank">
                            Nainital District Cooperative Bank
                          </option>
                          <option value="NALANDA CENTRAL COOPERATIVE BANK LIMITED">
                            NALANDA CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="NANDED DISCTRICT CENTRAL COOPERATIVE BANK">
                            NANDED DISCTRICT CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="NARMADA JHABUA GRAMIN BANK">
                            NARMADA JHABUA GRAMIN BANK
                          </option>
                          <option value="NATIONAL COOPERATIVE BANK LIMITED">
                            NATIONAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="NATIONAL URBAN COOPERATIVE  BANK LIMITED">
                            NATIONAL URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="NATIONAL URBAN COOPERATIVE BANK LIMITED">
                            NATIONAL URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="NAVSARJAN INDUSTRIAL COOPERATIVE BANK LIMITED">
                            NAVSARJAN INDUSTRIAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="NEW INDIA COOPERATIVE BANK LIMITED">
                            NEW INDIA COOPERATIVE BANK LIMITED
                          </option>
                          <option value="NIDHI COOPERATIVE BANK LIMITED">
                            NIDHI COOPERATIVE BANK LIMITED
                          </option>
                          <option value="NIRMAL URBAN COOPERATIVE BANK LIMITED">
                            NIRMAL URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="NKGSB COOPERATIVE BANK LIMITED">
                            NKGSB COOPERATIVE BANK LIMITED
                          </option>
                          <option value="NOBLE COOPERATIVE BANK LIMITED">
                            NOBLE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="NORTH EAST SMALL FINANCE BANK LIMITED">
                            NORTH EAST SMALL FINANCE BANK LIMITED
                          </option>
                          <option value="NORTH MALABAR GRAMIN BANK">
                            NORTH MALABAR GRAMIN BANK
                          </option>
                          <option value="NSDL Payments Bank Limited">
                            NSDL Payments Bank Limited
                          </option>
                          <option value="NUTAN NAGARIK SAHAKARI BANK LIMITED">
                            NUTAN NAGARIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="ODISHA GRAMEEN BANK">
                            ODISHA GRAMEEN BANK
                          </option>
                          <option value="PALI URBAN COOPERATIVE BANK LIMITED">
                            PALI URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="PALUS SAHAKARI BANK LIMITED">
                            PALUS SAHAKARI BANK LIMITED
                          </option>
                          <option value="PANCHMAHAL DISTRICT COOPERATIVE BANK LIMITED">
                            PANCHMAHAL DISTRICT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="PANCHSHEEL COOPERATIVE BANK ">
                            PANCHSHEEL COOPERATIVE BANK{" "}
                          </option>
                          <option value="PANIPAT URBAN COOPERATIVE BANK">
                            PANIPAT URBAN COOPERATIVE BANK
                          </option>
                          <option value="PARBHANI DISTRICT CENTRAL COOPERATIVE BANK">
                            PARBHANI DISTRICT CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="PARSHWANATH COOPERATIVE BANK LIMITED ">
                            PARSHWANATH COOPERATIVE BANK LIMITED{" "}
                          </option>
                          <option value="PASCHIM BANGA GRAMIN BANK">
                            PASCHIM BANGA GRAMIN BANK
                          </option>
                          <option value="PATAN NAGARIK SAHAKARI BANK LIMITED">
                            PATAN NAGARIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="PATLIPUTRA CENTRAL COOPERATIVE BANK LIMITED">
                            PATLIPUTRA CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="PAVANA SAHAKARI BANK LIMITED">
                            PAVANA SAHAKARI BANK LIMITED
                          </option>
                          <option value="PAYTM PAYMENTS BANK LIMITED">
                            PAYTM PAYMENTS BANK LIMITED
                          </option>
                          <option value="PEOPLES URBAN COOPERATIVE BANK LIMITED ">
                            PEOPLES URBAN COOPERATIVE BANK LIMITED{" "}
                          </option>
                          <option value="PIMPRI CHINCHWAD SAHAKARI BANK ">
                            PIMPRI CHINCHWAD SAHAKARI BANK{" "}
                          </option>
                          <option value="PITHORAGARH JILA SAHAKARI BANK">
                            PITHORAGARH JILA SAHAKARI BANK
                          </option>
                          <option value="POCHAMPALLY COOPERATIVE BANK ">
                            POCHAMPALLY COOPERATIVE BANK{" "}
                          </option>
                          <option value="POORNAWADI NAGRIK SAHAKARI BANK LIMITED">
                            POORNAWADI NAGRIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="PRAGATHI KRISHNA GRAMIN BANK">
                            PRAGATHI KRISHNA GRAMIN BANK
                          </option>
                          <option value="PRAGATI SAHAKARI BANK LIMITED ">
                            PRAGATI SAHAKARI BANK LIMITED{" "}
                          </option>
                          <option value="PRATAP COOPERATIVE BANK ">
                            PRATAP COOPERATIVE BANK{" "}
                          </option>
                          <option value="PRATHAMA BANK">PRATHAMA BANK</option>
                          <option value="PRERANA COOPERATIVE BANK LIMITED">
                            PRERANA COOPERATIVE BANK LIMITED
                          </option>
                          <option value="PRIME COOPERATIVE BANK LIMITED">
                            PRIME COOPERATIVE BANK LIMITED
                          </option>
                          <option value="PRIYADARSHANI NAGARI SAHAKARI BANK ">
                            PRIYADARSHANI NAGARI SAHAKARI BANK{" "}
                          </option>
                          <option value="PRIYADARSHANI NAGARI SAHAKARI BANK LTD">
                            PRIYADARSHANI NAGARI SAHAKARI BANK LTD
                          </option>
                          <option value="PT BANK MAYBANK INDONESIA TBK">
                            PT BANK MAYBANK INDONESIA TBK
                          </option>
                          <option value="PUNE CANTONMENT SAHAKARI BANK LIMITED">
                            PUNE CANTONMENT SAHAKARI BANK LIMITED
                          </option>
                          <option value="PUNE DISTRICT CENTRAL COOPERATIVE BANK LIMITED ">
                            PUNE DISTRICT CENTRAL COOPERATIVE BANK LIMITED{" "}
                          </option>
                          <option value="PUNE MERCHANTS CO-OPERATIVE BANK LTD">
                            PUNE MERCHANTS CO-OPERATIVE BANK LTD
                          </option>
                          <option value="PUNE PEOPLES COOPERATIVE BANK LIMITED ">
                            PUNE PEOPLES COOPERATIVE BANK LIMITED{" "}
                          </option>
                          <option value="PUNJAB AND MAHARSHTRA COOPERATIVE BANK">
                            PUNJAB AND MAHARSHTRA COOPERATIVE BANK
                          </option>
                          <option value="PUNJAB AND SIND BANK">
                            PUNJAB AND SIND BANK
                          </option>
                          <option value="PUNJAB GRAMIN BANK">
                            PUNJAB GRAMIN BANK
                          </option>
                          <option value="PUNJAB NATIONAL BANK">
                            PUNJAB NATIONAL BANK
                          </option>
                          <option value="PUNJAB NATIONAL BANK CREDIT CARD">
                            PUNJAB NATIONAL BANK CREDIT CARD
                          </option>
                          <option value="PURNEA DISTRICT CENTRAL COOPERATIVE BANK">
                            PURNEA DISTRICT CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="PURVANCHAL GRAMIN BANK">
                            PURVANCHAL GRAMIN BANK
                          </option>
                          <option value="QATAR NATIONAL BANK">
                            QATAR NATIONAL BANK
                          </option>
                          <option value="RABOBANK INTERNATIONAL">
                            RABOBANK INTERNATIONAL
                          </option>
                          <option value="RAE BARELI DISTRICT COOPERATIVE BANK LIMITED">
                            RAE BARELI DISTRICT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="RAIPUR URBAN MERCANTILE CO BANK LIMITED">
                            RAIPUR URBAN MERCANTILE CO BANK LIMITED
                          </option>
                          <option value="RAJAPUR URBAN COOPERATIVE BANK LIMITED">
                            RAJAPUR URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="RAJARAM BAPU SAHAKARI BANK LTD">
                            RAJARAM BAPU SAHAKARI BANK LTD
                          </option>
                          <option value="RAJARAMBAPU SAHAKARI BANK LIMITED">
                            RAJARAMBAPU SAHAKARI BANK LIMITED
                          </option>
                          <option value="RAJARSHI SHAHU SAHAKARI BANK LIMITED">
                            RAJARSHI SHAHU SAHAKARI BANK LIMITED
                          </option>
                          <option value="RAJASTHAN MARUDHARA GRAMIN BANK">
                            RAJASTHAN MARUDHARA GRAMIN BANK
                          </option>
                          <option value="RAJGURUNAGAR SAHAKARI BANK LIMITED">
                            RAJGURUNAGAR SAHAKARI BANK LIMITED
                          </option>
                          <option value="RAJKOT DISTRICT CENTRAL COOPERATIVE BANK LIMITED">
                            RAJKOT DISTRICT CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="RAJKOT NAGRIK SAHAKARI BANK LIMITED">
                            RAJKOT NAGRIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="RAJKOT PEOPLES COOPERATIVE BANK LIMITED">
                            RAJKOT PEOPLES COOPERATIVE BANK LIMITED
                          </option>
                          <option value="RAMESHWAR COOPERATIVE BANK ">
                            RAMESHWAR COOPERATIVE BANK{" "}
                          </option>
                          <option value="RAMPUR ZILA SAHAKARI BANK LIMITED">
                            RAMPUR ZILA SAHAKARI BANK LIMITED
                          </option>
                          <option value="RATNAGIRI DISTRICT CENTRAL COOPERATIVE BANK LIMIT">
                            RATNAGIRI DISTRICT CENTRAL COOPERATIVE BANK LIMIT
                          </option>
                          <option value="RBL BANK LIMITED">
                            RBL BANK LIMITED
                          </option>
                          <option value="RENDAL SAHAKARI BANK LIMITED">
                            RENDAL SAHAKARI BANK LIMITED
                          </option>
                          <option value="RESERVE BANK OF INDIA">
                            RESERVE BANK OF INDIA
                          </option>
                          <option value="RUSHIKULYA GRAMIN BANK">
                            RUSHIKULYA GRAMIN BANK
                          </option>
                          <option value="SABARKANTHA DISTRICT CENTRAL COOPERATIVE BANK LIMI">
                            SABARKANTHA DISTRICT CENTRAL COOPERATIVE BANK LIMI
                          </option>
                          <option value="SADHANA SAHAKARI BANK LIMITED">
                            SADHANA SAHAKARI BANK LIMITED
                          </option>
                          <option value="SAHEBRAO DESHMUKH COOPERATIVE BANK LIMITED">
                            SAHEBRAO DESHMUKH COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SAHYADRI  SAHAKARI BANK">
                            SAHYADRI SAHAKARI BANK
                          </option>
                          <option value="SAIBABA NAGARI SAHAKARI  BANK LIMITED">
                            SAIBABA NAGARI SAHAKARI BANK LIMITED
                          </option>
                          <option value="SAMARTH SAHAKARI BANK LIMITED">
                            SAMARTH SAHAKARI BANK LIMITED
                          </option>
                          <option value="SAMATA SAHAKARI BANK">
                            SAMATA SAHAKARI BANK
                          </option>
                          <option value="SAMATA SAHAKARI BANK LIMITED">
                            SAMATA SAHAKARI BANK LIMITED
                          </option>
                          <option value="SAMPADA SAHAKARI BANK LIMITED">
                            SAMPADA SAHAKARI BANK LIMITED
                          </option>
                          <option value="SAMRUDDHI COOPERATIVE BANK LIMITED">
                            SAMRUDDHI COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SANGLI SAHAKARI BANK LIMITED">
                            SANGLI SAHAKARI BANK LIMITED
                          </option>
                          <option value="SANGOLA URBAN COOPERATIVE BANK LIMITED">
                            SANGOLA URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SANMATI SAHAKARI BANK">
                            SANMATI SAHAKARI BANK
                          </option>
                          <option value="SANMATI SAHAKARI BANK LIMITED">
                            SANMATI SAHAKARI BANK LIMITED
                          </option>
                          <option value="SARASPUR NAGARIK COOPERATIVE BANK LIMITED">
                            SARASPUR NAGARIK COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SARASWAT COOPERATIVE BANK LIMITED">
                            SARASWAT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SARDAR BHILADWALA PARDI PEOPLE COOPERATIVE BANK">
                            SARDAR BHILADWALA PARDI PEOPLE COOPERATIVE BANK
                          </option>
                          <option value="SARVA HARYANA GRAMIN BANK">
                            SARVA HARYANA GRAMIN BANK
                          </option>
                          <option value="SARVA UP GRAMIN BANK">
                            SARVA UP GRAMIN BANK
                          </option>
                          <option value="SARVODAYA COOPERATIVE BANK">
                            SARVODAYA COOPERATIVE BANK
                          </option>
                          <option value="SARVODAYA SAH BANK">
                            SARVODAYA SAH BANK
                          </option>
                          <option value="SATLUJ GRAMIN BANK BATHINDA">
                            SATLUJ GRAMIN BANK BATHINDA
                          </option>
                          <option value="SATPURA NARMADA KSHETRIYA GRAMIN BANK">
                            SATPURA NARMADA KSHETRIYA GRAMIN BANK
                          </option>
                          <option value="SAURASHTRA GRAMIN BANK">
                            SAURASHTRA GRAMIN BANK
                          </option>
                          <option value="SBER BANK">SBER BANK</option>
                          <option value="SHAHJAHANPUR DISTRICT CENTRAL COOPERATIVE BANK LIM">
                            SHAHJAHANPUR DISTRICT CENTRAL COOPERATIVE BANK LIM
                          </option>
                          <option value="SHARAD SAHAKARI BANK LIMITED">
                            SHARAD SAHAKARI BANK LIMITED
                          </option>
                          <option value="SHINHAN BANK">SHINHAN BANK</option>
                          <option value="SHIVAJI NAGARI PAITHAN">
                            SHIVAJI NAGARI PAITHAN
                          </option>
                          <option value="SHIVAJIRAO BHOSALE SAHAKARI BANK LIMITED">
                            SHIVAJIRAO BHOSALE SAHAKARI BANK LIMITED
                          </option>
                          <option value="SHIVALIK MERCANTILE COOPERATIVE BANK LIMITED">
                            SHIVALIK MERCANTILE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SHREE BASAVESHWAR COOPERATIVE BANK ">
                            SHREE BASAVESHWAR COOPERATIVE BANK{" "}
                          </option>
                          <option value="SHREE BASAVESHWAR URBAN COOPERATIVE BANK LIMITED">
                            SHREE BASAVESHWAR URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SHREE DHARATI COOPERATIVE BANK ">
                            SHREE DHARATI COOPERATIVE BANK{" "}
                          </option>
                          <option value="SHREE DHARTI COOPERATIVE BANK LIMITED">
                            SHREE DHARTI COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SHREE KADI NAGRIK SAHAKARI BANK ">
                            SHREE KADI NAGRIK SAHAKARI BANK{" "}
                          </option>
                          <option value="SHREE MAHAVIR SAHAKARI BANK LIMITED ">
                            SHREE MAHAVIR SAHAKARI BANK LIMITED{" "}
                          </option>
                          <option value="SHREE MURUGHARAJENDRA COOPERATIVE BANK LIMITED">
                            SHREE MURUGHARAJENDRA COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SHREE SHARADA SAHAKARI BANK ">
                            SHREE SHARADA SAHAKARI BANK{" "}
                          </option>
                          <option value="SHREE WARANA SAHAKARI BANK LIMITED">
                            SHREE WARANA SAHAKARI BANK LIMITED
                          </option>
                          <option value="SHREYAS GRAMIN BANK">
                            SHREYAS GRAMIN BANK
                          </option>
                          <option value="SHRI ADINATH COOPERATIVE BANK LIMITED">
                            SHRI ADINATH COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SHRI ARIHANT COOPERATIVE BANK LIMITED">
                            SHRI ARIHANT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SHRI BASAVESHWAR SAHAKARI BANK ">
                            SHRI BASAVESHWAR SAHAKARI BANK{" "}
                          </option>
                          <option value="SHRI CHHATRAPATI RAJASHRI SHAHU URBAN COOPERATIVE">
                            SHRI CHHATRAPATI RAJASHRI SHAHU URBAN COOPERATIVE
                          </option>
                          <option value="SHRI JANATA SAHAKARI BANK LIMITED">
                            SHRI JANATA SAHAKARI BANK LIMITED
                          </option>
                          <option value="SHRI MAHALAXMI COOPERATIVE BANK LIMITED">
                            SHRI MAHALAXMI COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SHRI PANCHGANGA NAGARI SAHAKARI BANK LIMITED">
                            SHRI PANCHGANGA NAGARI SAHAKARI BANK LIMITED
                          </option>
                          <option value="SHRI VEERSHAIV COOPERATIVE BANK LIMITED">
                            SHRI VEERSHAIV COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SHRIMANT MALOJIRAJE SAHAKARI BANK LIMITED">
                            SHRIMANT MALOJIRAJE SAHAKARI BANK LIMITED
                          </option>
                          <option value="SHUSHRUTI SOUAHRDA SAHAKRA BANK">
                            SHUSHRUTI SOUAHRDA SAHAKRA BANK
                          </option>
                          <option value="SIKKIM STATE CO-OPERATIVE BANK LTD">
                            SIKKIM STATE CO-OPERATIVE BANK LTD
                          </option>
                          <option value="SINDHUDURG DIST CENT COOPERATIVE BANK LIMITED">
                            SINDHUDURG DIST CENT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SIWAN CNETRAL COOPERATIVE BANK LIMITED">
                            SIWAN CNETRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SMRITI NAGRIK SAHAKARI BANK LIMITED">
                            SMRITI NAGRIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="SOCIETE GENERALE BANK LIMITED">
                            SOCIETE GENERALE BANK LIMITED
                          </option>
                          <option value="SOLAPUR JANATA SAHAKARI BANK LIMITED">
                            SOLAPUR JANATA SAHAKARI BANK LIMITED
                          </option>
                          <option value="SOLAPUR SIDDHESHWAR SAHAKARI BANK LIMITED">
                            SOLAPUR SIDDHESHWAR SAHAKARI BANK LIMITED
                          </option>
                          <option value="SONALI BANK LIMITED">
                            SONALI BANK LIMITED
                          </option>
                          <option value="SONBHADRA NAGAR SAHAKARI BANK LIMITED">
                            SONBHADRA NAGAR SAHAKARI BANK LIMITED
                          </option>
                          <option value="SOUTH INDIAN BANK">
                            SOUTH INDIAN BANK
                          </option>
                          <option value="SREE CHARAN BANK ">
                            SREE CHARAN BANK{" "}
                          </option>
                          <option value="SREENIDHI SOUH BANK">
                            SREENIDHI SOUH BANK
                          </option>
                          <option value="SREENIDHI SOUH SAHAK BANK ">
                            SREENIDHI SOUH SAHAK BANK{" "}
                          </option>
                          <option value="SRI GOKARNATH COOPERATIVE BANK LIMITED">
                            SRI GOKARNATH COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SRI GURU RAGHAVENDRA SAHAKARA BANK ">
                            SRI GURU RAGHAVENDRA SAHAKARA BANK{" "}
                          </option>
                          <option value="SRI SATYA SAI NAGARIK SAHAKARI BANK">
                            SRI SATYA SAI NAGARIK SAHAKARI BANK
                          </option>
                          <option value="SRI SUDHA COOPERATIVE BANK LIMITED">
                            SRI SUDHA COOPERATIVE BANK LIMITED
                          </option>
                          <option value="STANDARD CHARTERED BANK">
                            STANDARD CHARTERED BANK
                          </option>
                          <option value="STANDARD CHARTERED CREDIT CARD">
                            STANDARD CHARTERED CREDIT CARD
                          </option>
                          <option value="STATE BANK OF HYDERABAD, DECCAN GRAMEENA BANK">
                            STATE BANK OF HYDERABAD, DECCAN GRAMEENA BANK
                          </option>
                          <option value="STATE BANK OF INDIA">
                            STATE BANK OF INDIA
                          </option>
                          <option value="STATE BANK OF INDIA CREDIT CARD">
                            STATE BANK OF INDIA CREDIT CARD
                          </option>
                          <option value="STATE BANK OF MAURITIUS LIMITED">
                            STATE BANK OF MAURITIUS LIMITED
                          </option>
                          <option value="STERLING URBAN COOPERATIVE BANK LIMITED">
                            STERLING URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SUCO SOUHARDA SAHAKARI BANK LIMITED">
                            SUCO SOUHARDA SAHAKARI BANK LIMITED
                          </option>
                          <option value="SUDHA COOPERATIVE URBAN BANK LIMITED">
                            SUDHA COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="SUMERPUR MERC. URBAN COOPERATIVE BANK LIMITED">
                            SUMERPUR MERC. URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SUNDARLAL SAWJI URBAN COOPERATIVE BANK LIMITED">
                            SUNDARLAL SAWJI URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SURAT MERC COOPERATIVE BANK ">
                            SURAT MERC COOPERATIVE BANK{" "}
                          </option>
                          <option value="SURAT NATIONAL COOPERATIVE BANK LIMITED">
                            SURAT NATIONAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SURYODAY SMALL FINANCE BANK LIMITED">
                            SURYODAY SMALL FINANCE BANK LIMITED
                          </option>
                          <option value="SUTEX COOPERATIVE BANK LIMITED">
                            SUTEX COOPERATIVE BANK LIMITED
                          </option>
                          <option value="SUVARNAYUG SAHAKARI BANK LIMITED">
                            SUVARNAYUG SAHAKARI BANK LIMITED
                          </option>
                          <option value="TAMILNAD MERCANTILE BANK LIMITED">
                            TAMILNAD MERCANTILE BANK LIMITED
                          </option>
                          <option value="TAMILNADU GRAMA BANK">
                            TAMILNADU GRAMA BANK
                          </option>
                          <option value="TAMLUK GHATAL CENTRAL COOPERATIVE BANK LIMITED">
                            TAMLUK GHATAL CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="TEHRI GARHWAL ZILA SAHAKARI BANK LIMITED, ICICI BA">
                            TEHRI GARHWAL ZILA SAHAKARI BANK LIMITED, ICICI BA
                          </option>
                          <option value="TEHRI GARHWAL ZILA SAHAKARI BANK, IDBI BANK">
                            TEHRI GARHWAL ZILA SAHAKARI BANK, IDBI BANK
                          </option>
                          <option value="TELANGANA GRAMEEN BANK">
                            TELANGANA GRAMEEN BANK
                          </option>
                          <option value="TELANGANA STATE COOPERATIVE BANK APEX BANK">
                            TELANGANA STATE COOPERATIVE BANK APEX BANK
                          </option>
                          <option value="TEXTILE TRADERS COOPERATIVE BANK LIMITED">
                            TEXTILE TRADERS COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE ADARSH COOPERATIVE URBAN BANK LIMITED">
                            THE ADARSH COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="THE AHMEDNAGAR DIST CEN COOPERATIVE BANK LIMITED">
                            THE AHMEDNAGAR DIST CEN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE AHMEDNAGAR MER COOPERATIVE BANK LIMITED">
                            THE AHMEDNAGAR MER COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE AJARA URBAN COOPERATIVE BANK LIMITED">
                            THE AJARA URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE AKOLA DISTRICT CENTRAL COOPERATIVE BANK">
                            THE AKOLA DISTRICT CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="THE AMRITSAR CENTRAL COOPERATIVE BANK LIMITED">
                            THE AMRITSAR CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE ANAND MERCANTILE COOPERATIVE BANK">
                            THE ANAND MERCANTILE COOPERATIVE BANK
                          </option>
                          <option value="THE ANDHRA PRADESH STATE COOPERATIVE BANK LIMITED">
                            THE ANDHRA PRADESH STATE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE ASKA COOPERATIVE CENTRAL BANK LIMITED">
                            THE ASKA COOPERATIVE CENTRAL BANK LIMITED
                          </option>
                          <option value="THE ASSAM COOPERATIVE APEX BANK LIMITED">
                            THE ASSAM COOPERATIVE APEX BANK LIMITED
                          </option>
                          <option value="THE BANK OF NOVA SCOTIA">
                            THE BANK OF NOVA SCOTIA
                          </option>
                          <option value="THE BANKI CENTRAL COOPERATIVE BANK LIMITED">
                            THE BANKI CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE BARAMATI SAHAKARI BANK LIMITED">
                            THE BARAMATI SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE BARDOLI  NAGRIK SAHAKARI BANK LIMITED">
                            THE BARDOLI NAGRIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE BARMER CENTRAL COOPERATIVE BANK LIMITED">
                            THE BARMER CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE BARODA CITY COOPERATIVE BANK LIMITED">
                            THE BARODA CITY COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE BEGUSARAI DISTRICT CENTRAL COOPERATIVE BANK">
                            THE BEGUSARAI DISTRICT CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="THE BELLARY DISTRICT COOPERATIVE BANK LIMITED">
                            THE BELLARY DISTRICT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE BERHAMPORE COOPERATIVE CENTRAL BANK LIMITED">
                            THE BERHAMPORE COOPERATIVE CENTRAL BANK LIMITED
                          </option>
                          <option value="THE BHAGALPUR CENTRAL COOPERATIVE BANK">
                            THE BHAGALPUR CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="THE BHAGYALAKSHMI MAHILA SAHAKARI BANK">
                            THE BHAGYALAKSHMI MAHILA SAHAKARI BANK
                          </option>
                          <option value="THE BHAGYODAYA COOPERATIVE BANK LIMITED">
                            THE BHAGYODAYA COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE BHANDARA DISTRICT CENTRAL COOPERATIVE BANK LIM">
                            THE BHANDARA DISTRICT CENTRAL COOPERATIVE BANK LIM
                          </option>
                          <option value="THE BHARAT COOPERATIVE BANK LIMITED">
                            THE BHARAT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE BHATKAL URBAN COOPERATIVE BANK LIMITED">
                            THE BHATKAL URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE BHAWANIPATNA CENTRAL COOPERATIVE BANK LIMITED">
                            THE BHAWANIPATNA CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE BHIWANI CENTRAL COOPERATIVE  BANK LIMITED">
                            THE BHIWANI CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE BHIWANI CENTRAL COOPERATIVE BANK LTD">
                            THE BHIWANI CENTRAL COOPERATIVE BANK LTD
                          </option>
                          <option value="THE BICHOLIUM URBAN COOPERATIVE BANK LIMITED">
                            THE BICHOLIUM URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE BURDWAN CENTRAL COOPERATIVE BANK LIMITED">
                            THE BURDWAN CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE BUSINESS COOPERATIVE BANK ">
                            THE BUSINESS COOPERATIVE BANK{" "}
                          </option>
                          <option value="THE CHANASMA NAGARIK SAHAKARI BANK LIMITED">
                            THE CHANASMA NAGARIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE CHANDIGARH STATE COOPERATIVE BANK LIMITED">
                            THE CHANDIGARH STATE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE CHANDRAPUR DCC BANK ">
                            THE CHANDRAPUR DCC BANK{" "}
                          </option>
                          <option value="THE CHIKHLI URBAN COOPERATIVE BANK LIMITED">
                            THE CHIKHLI URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE CITIZEN COOPERATIVE BANK LIMITED">
                            THE CITIZEN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE COMMERCIAL COOPERATIVE BANK LIMITED">
                            THE COMMERCIAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE COOPERATIVE BANK OF MEHSANA LIMITED ">
                            THE COOPERATIVE BANK OF MEHSANA LIMITED{" "}
                          </option>
                          <option value="THE COOPERATIVE BANK OF RAJKOT ">
                            THE COOPERATIVE BANK OF RAJKOT{" "}
                          </option>
                          <option value="THE COSMOS COOPERATIVE BANK LIMITED">
                            THE COSMOS COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE CUDDALORE DISTRICT CENTRAL COOPERATIVE BANK LIMITED">
                            THE CUDDALORE DISTRICT CENTRAL COOPERATIVE BANK
                            LIMITED
                          </option>
                          <option value="THE DAHOD URBAN COOPERATIVE BANK LIMITED">
                            THE DAHOD URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE DECCAN MERCHANTS COOPERATIVE BANK LIMITED">
                            THE DECCAN MERCHANTS COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE DELHI ST COOPERATIVE BANK ">
                            THE DELHI ST COOPERATIVE BANK{" "}
                          </option>
                          <option value="THE DELHI STATE COOPERATIVE BANK LIMITED">
                            THE DELHI STATE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE DEOLA MERCHANT S COOPERATIVE BANK LIMITED">
                            THE DEOLA MERCHANT S COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE DEOLA MERCHANTS COOPERATIVE BANK LIMITED">
                            THE DEOLA MERCHANTS COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE DHANERA MERCANTILE COOPERATIVE BANK LIMITED">
                            THE DHANERA MERCANTILE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE DHARMAPURI DISTRICT CENTRAL COOPERATIVE BANK LIMITED">
                            THE DHARMAPURI DISTRICT CENTRAL COOPERATIVE BANK
                            LIMITED
                          </option>
                          <option value="THE DISTRICT CO-OPERATIVE BANK LTD AGRA">
                            THE DISTRICT CO-OPERATIVE BANK LTD AGRA
                          </option>
                          <option value="THE DISTRICT COOPERATIVE BANK LIMITED">
                            THE DISTRICT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE DISTRICT COOPERATIVE CENTRAL BANK LIMITED ">
                            THE DISTRICT COOPERATIVE CENTRAL BANK LIMITED{" "}
                          </option>
                          <option value="THE DUNGARPUR CENTRAL COOPERATIVE BANK LIMITED">
                            THE DUNGARPUR CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE EENADU COOPERATIVE URBAN BANK LIMITED">
                            THE EENADU COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="THE ERODE DISTRICT CENTRAL COOPERATIVE BANK LIMITE">
                            THE ERODE DISTRICT CENTRAL COOPERATIVE BANK LIMITE
                          </option>
                          <option value="THE FEDERAL BANK LIMITED">
                            THE FEDERAL BANK LIMITED
                          </option>
                          <option value="THE FEDERAL BANK LIMITED, AUCB BR ALENGAD">
                            THE FEDERAL BANK LIMITED, AUCB BR ALENGAD
                          </option>
                          <option value="THE FEDERAL BANK LIMITED, AUCB BR CHUNANGAMVELI">
                            THE FEDERAL BANK LIMITED, AUCB BR CHUNANGAMVELI
                          </option>
                          <option value="THE GANDEVI PEOPLES COOPERATIVE BANK LIMITED">
                            THE GANDEVI PEOPLES COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE GANDHIDHAM COOPERATIVE BANK LIMITED">
                            THE GANDHIDHAM COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE GANDHIDHAM MERCANTILE COOPERATIVE BANK LIMITED">
                            THE GANDHIDHAM MERCANTILE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE GANDHINAGAR URBAN COOPERATIVE BANK LIMITED">
                            THE GANDHINAGAR URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE GAYATRI COOPERATIVE URBAN BANK LIMITED">
                            THE GAYATRI COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="THE GIRIDIH CENTRAL COOPERATIVE BANK LIMITED">
                            THE GIRIDIH CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE GODHRA CITY COOPERATIVE BANK LIMITED">
                            THE GODHRA CITY COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE GODHRA URBAN COOPERATIVE BANK LIMITED">
                            THE GODHRA URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE GOPALGANJ CENTRAL GOPALGANJ COOPERATIVE BANK L">
                            THE GOPALGANJ CENTRAL GOPALGANJ COOPERATIVE BANK L
                          </option>
                          <option value="THE GREATER BOMBAY COOPERATIVE BANK LIMITED">
                            THE GREATER BOMBAY COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE GUJARAT STATE CO-OPERATIVE BANK LTD">
                            THE GUJARAT STATE CO-OPERATIVE BANK LTD
                          </option>
                          <option value="THE GUJARAT STATE CO-OPERATIVE BANK LTD">
                            THE GUJARAT STATE CO-OPERATIVE BANK LTD
                          </option>
                          <option value="THE GURDASPUR CENTRAL COOPERATIVE BANK LIMITED">
                            THE GURDASPUR CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE GURGAON CENTRAL  COOPERATIVE BANK LIMITED">
                            THE GURGAON CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE HARYANA STATE COOPERATIVE  APEX BANK LIMITED">
                            THE HARYANA STATE COOPERATIVE APEX BANK LIMITED
                          </option>
                          <option value="THE HASSAN DISTRICT CENTRAL CO-OPERATIVE BANK LTD">
                            THE HASSAN DISTRICT CENTRAL CO-OPERATIVE BANK LTD
                          </option>
                          <option value="THE HASTI COOPERATIVE BANK LIMITED">
                            THE HASTI COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE HINDUSTHAN CO OP BANK LIMITED">
                            THE HINDUSTHAN CO OP BANK LIMITED
                          </option>
                          <option value="THE HYDERABAD DISTRICT CO OPERATIVE CENTRAL BANK">
                            THE HYDERABAD DISTRICT CO OPERATIVE CENTRAL BANK
                          </option>
                          <option value="THE HYDERABAD DISTRICT COOPERATIVE CENTRAL BANK LI">
                            THE HYDERABAD DISTRICT COOPERATIVE CENTRAL BANK LI
                          </option>
                          <option value="THE JAIN SAHAKARI BANK LIMITED">
                            THE JAIN SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE JALGAON DISTRICT CENTRAL COOPERATIVE BANK LIMI">
                            THE JALGAON DISTRICT CENTRAL COOPERATIVE BANK LIMI
                          </option>
                          <option value="THE JALGAON PEOPELS COOPERATIVE BANK LIMITED">
                            THE JALGAON PEOPELS COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE JALPAIGURI CTRL BANK ">
                            THE JALPAIGURI CTRL BANK{" "}
                          </option>
                          <option value="THE JAMKHANDI URBAN COOPERATIVE BANK LIMITED">
                            THE JAMKHANDI URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE JHAJJAR CENTRAL COOPERATIVE  BANK LIMITED">
                            THE JHAJJAR CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE JIND CENTRAL COOPERATIVE  BANK LIMITED">
                            THE JIND CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE JODHPUR CENTRAL COOPERATIVE BANK LIMITED">
                            THE JODHPUR CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE JUNAGADH COMM COOPERATIVE BANK LIMITED">
                            THE JUNAGADH COMM COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KAIRA DISTRICT CENTRAL COOPERATIVE BANK LIMITE">
                            THE KAIRA DISTRICT CENTRAL COOPERATIVE BANK LIMITE
                          </option>
                          <option value="THE KANAKAMAHALAKSHMI COOPERATIVE BANK LIMITED">
                            THE KANAKAMAHALAKSHMI COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KANCHIPURAM CENTRAL COOPERATIVE BANK LIMITED">
                            THE KANCHIPURAM CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KANGRA CENTRAL COOPERATIVE BANK LIMITED">
                            THE KANGRA CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KANGRA COOPERATIVE BANK LIMITED">
                            THE KANGRA COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KANNUR COOPERATIVE URBAN BANK LIMITED">
                            THE KANNUR COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="THE KAPURTHALA CENTRAL  COOPERATIVE BANK LIMITED">
                            THE KAPURTHALA CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KARAD URBAN COOPERATIVE BANK LIMITED">
                            THE KARAD URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KARIMNAGAR DISTRICT COOPERATIVE CENTRAL BANK L">
                            THE KARIMNAGAR DISTRICT COOPERATIVE CENTRAL BANK L
                          </option>
                          <option value="THE KARNAL CENTRAL COOPERATIVE BANK LIMITED">
                            THE KARNAL CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KARNAVATI COOPERATIVE BANK LIMITED ">
                            THE KARNAVATI COOPERATIVE BANK LIMITED{" "}
                          </option>
                          <option value="THE KASARAGOD DISTRICT COOPERATIVE BANK LIMITED">
                            THE KASARAGOD DISTRICT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KERALA STATE COOPERATIVE BANK LIMITED">
                            THE KERALA STATE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KHAGARIA DISTRICTCENTRAL COOPERATIVE BANK LIMI">
                            THE KHAGARIA DISTRICTCENTRAL COOPERATIVE BANK LIMI
                          </option>
                          <option value="THE KHEDA PEOPLES COOPERATIVE BANK LIMITED">
                            THE KHEDA PEOPLES COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KODUNGALLUR TOWN COOPERATIVE BANK LIMITED">
                            THE KODUNGALLUR TOWN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KOLHAPUR URBAN COOPERATIVE BANK LIMITED">
                            THE KOLHAPUR URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KOLLAM DISTRICT COOPERATIVE BANK LIMITED">
                            THE KOLLAM DISTRICT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KORAPUT CENTRAL COOPERATIVE BANK LIMITED">
                            THE KORAPUT CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE KRANTHI COOPERATIVE URBAN BANK LIMITED">
                            THE KRANTHI COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="THE KURLA NAGARIK SAHAKARI BANK LIMITED">
                            THE KURLA NAGARIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE KURMANCHAL NAGAR SAHAKARI BANK LIMITED">
                            THE KURMANCHAL NAGAR SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE LATUR URBAN COOPERATIVE BANK LIMITED">
                            THE LATUR URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE MADANAPALLE COOPERATIVE TOWN BANK LIMITED">
                            THE MADANAPALLE COOPERATIVE TOWN BANK LIMITED
                          </option>
                          <option value="THE MADURAI DISTRICT CENTRAL COOPERATIVE BANK LIMITED">
                            THE MADURAI DISTRICT CENTRAL COOPERATIVE BANK
                            LIMITED
                          </option>
                          <option value="THE MAHARAJA COOPERATIVE URBAN BANK LIMITED">
                            THE MAHARAJA COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="THE MALAD SAHAKARI BANK LIMITED">
                            THE MALAD SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE MALKAPUR URB COOPERATIVE BANK LIMITED">
                            THE MALKAPUR URB COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE MANDVI NAGRIK SAHAKARI BANK LIMITED">
                            THE MANDVI NAGRIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE MANGALORE CATHOLIC COOPERATIVE BANK LIMITED">
                            THE MANGALORE CATHOLIC COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE MANJERI COOPERATIVE URBAN BANK LIMITED">
                            THE MANJERI COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="THE MANMANDIR COOPERATIVE BANK LIMITED">
                            THE MANMANDIR COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE MATTANCHERRY SARVAJANIK COOPERATIVE BANK LIMIT">
                            THE MATTANCHERRY SARVAJANIK COOPERATIVE BANK LIMIT
                          </option>
                          <option value="THE MAYANI URBAN COOPERATIVE BANK LIMITED">
                            THE MAYANI URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE MEHSANA URBAN COOPERATIVE BANK">
                            THE MEHSANA URBAN COOPERATIVE BANK
                          </option>
                          <option value="THE MERCHANTS SOUHARDA SAHAKARA BANK ">
                            THE MERCHANTS SOUHARDA SAHAKARA BANK{" "}
                          </option>
                          <option value="THE MODA CENTRAL COOPERATIVE BANK LIMITED">
                            THE MODA CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE MODASA NAGARIK SAHAKARI BANK LIMITED ">
                            THE MODASA NAGARIK SAHAKARI BANK LIMITED{" "}
                          </option>
                          <option value="THE MUMBAI DISTRICT CENTRAL COOPERATIVE BANK LIMIT">
                            THE MUMBAI DISTRICT CENTRAL COOPERATIVE BANK LIMIT
                          </option>
                          <option value="THE MUNICIPAL COOPERATIVE BANK LIMITED">
                            THE MUNICIPAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE MUSLIM COOPERATIVE BANK LIMITED">
                            THE MUSLIM COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE NAGALAND STATE COOPERATIVE BANK LIMITED">
                            THE NAGALAND STATE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE NAGAR SAHAKARI BANK LIMITED">
                            THE NAGAR SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE NAINITAL BANK LIMITED">
                            THE NAINITAL BANK LIMITED
                          </option>
                          <option value="THE NANDURA URBAN COOPERATIVE BANK LIMITED">
                            THE NANDURA URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE NARODA NAGRIK COOPERATIVE BANK LIMITED">
                            THE NARODA NAGRIK COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE NASHIK JILHA MAHILA SAHAKARI BANK LIMITED">
                            THE NASHIK JILHA MAHILA SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE NASIK MERCHANTS COOPERATIVE BANK LIMITED">
                            THE NASIK MERCHANTS COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE NATIONAL COOPERATIVE BANK LIMITED ">
                            THE NATIONAL COOPERATIVE BANK LIMITED{" "}
                          </option>
                          <option value="The Navnirman Co - Op. Bank Ltd.">
                            The Navnirman Co - Op. Bank Ltd.
                          </option>
                          <option value="THE NAWADA CENTRAL COOPERATIVE BANK LIMITED">
                            THE NAWADA CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE NAWANAGAR COOPERATIVE BANK LIMITED">
                            THE NAWANAGAR COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE NAWANSHAHR CENTRAL COOPERATIVE  BANK LIMITED">
                            THE NAWANSHAHR CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE NEW URBAN COOPERATIVE BANK LIMITED ">
                            THE NEW URBAN COOPERATIVE BANK LIMITED{" "}
                          </option>
                          <option value="THE NILAMBUR COOPERATIVE URBAN BANK LIMITED">
                            THE NILAMBUR COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="THE NILGIRIS DISTRICT CENTRAL COOPERATIVE BANK LIM">
                            THE NILGIRIS DISTRICT CENTRAL COOPERATIVE BANK LIM
                          </option>
                          <option value="THE OTTAPALAM COOPERATIVE BANK LIMITED">
                            THE OTTAPALAM COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE PANDHARPUR  MERCHANTS COOPERATIVE BANK LIMITED">
                            THE PANDHARPUR MERCHANTS COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE PANDHARPUR URBAN COOPERATIVE  BANK LIMITED PAN">
                            THE PANDHARPUR URBAN COOPERATIVE BANK LIMITED PAN
                          </option>
                          <option value="THE PANIPAT CENTRAL COOPERATIVE BANK LIMITED">
                            THE PANIPAT CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE PEOPLE S URBAN COOPERATIVE BANK,">
                            THE PEOPLE S URBAN COOPERATIVE BANK,
                          </option>
                          <option value="THE POCHAMPALLY COOPERATIVE URBAN BANK LIMITED">
                            THE POCHAMPALLY COOPERATIVE URBAN BANK LIMITED
                          </option>
                          <option value="THE PURNIA DISTRICT CENTRAL COOPERATIVE BANK LIMIT">
                            THE PURNIA DISTRICT CENTRAL COOPERATIVE BANK LIMIT
                          </option>
                          <option value="THE RAIGAD DISTRICT CENTRAL COOPERATIVE BANK LIMIT">
                            THE RAIGAD DISTRICT CENTRAL COOPERATIVE BANK LIMIT
                          </option>
                          <option value="THE RAILWAY COOPERATIVE BANK LIMITED, MYSORE">
                            THE RAILWAY COOPERATIVE BANK LIMITED, MYSORE
                          </option>
                          <option value="THE RAJASTHAN STATE COOPERATIVE BANK LTD">
                            THE RAJASTHAN STATE COOPERATIVE BANK LTD
                          </option>
                          <option value="THE RAJKOT COMMERCIAL COOPERATIVE BANK LIMITED">
                            THE RAJKOT COMMERCIAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE RAMANATHAPURAM DISTRICT CENTRAL CO-OPERATIVE B">
                            THE RAMANATHAPURAM DISTRICT CENTRAL CO-OPERATIVE B
                          </option>
                          <option value="THE RANUJ NAGRIK SAHAKARI BANK LIMITED">
                            THE RANUJ NAGRIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE RATNAKAR BANK LIMITED CREDIT CARD">
                            THE RATNAKAR BANK LIMITED CREDIT CARD
                          </option>
                          <option value="THE REWARI CENTRAL  COOPERATIVE BANK LIMITED">
                            THE REWARI CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE ROHIKA CENTRAL COOPERATIVE BANK">
                            THE ROHIKA CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="THE ROHTAK CENTRAL COOPERATIVE  BANK LIMITED">
                            THE ROHTAK CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE ROYAL BANK OF SCOTLAND N V">
                            THE ROYAL BANK OF SCOTLAND N V
                          </option>
                          <option value="THE SAMASTIPUR DISTRICT CENTRAL COOPERATIVE BANK L">
                            THE SAMASTIPUR DISTRICT CENTRAL COOPERATIVE BANK L
                          </option>
                          <option value="THE SAMMCO BANK LIMITED ">
                            THE SAMMCO BANK LIMITED{" "}
                          </option>
                          <option value="THE SANGAMNER MERCH COOPERATIVE BANK LIMITED">
                            THE SANGAMNER MERCH COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE SANGLI DISTRICT CENTRAL COOPERATIVE BANK LIMIT">
                            THE SANGLI DISTRICT CENTRAL COOPERATIVE BANK LIMIT
                          </option>
                          <option value="THE SANGRUR CENTRAL COOPERATIVE BANK LIMITED">
                            THE SANGRUR CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE SARDARGANJ MERCANTILE  COOPERATIVE BANK LIMITE">
                            THE SARDARGANJ MERCANTILE COOPERATIVE BANK LIMITE
                          </option>
                          <option value="THE SARVODAYA NAGRIK SAHAKARI BANK LIMITED">
                            THE SARVODAYA NAGRIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE SATARA DISTRICT CENTRAL COOPERATIVE BANK LIMIT">
                            THE SATARA DISTRICT CENTRAL COOPERATIVE BANK LIMIT
                          </option>
                          <option value="THE SATARA SAHAKARI BANK ">
                            THE SATARA SAHAKARI BANK{" "}
                          </option>
                          <option value="THE SAURASHTRA COOPERATIVE  BANK LIMITED">
                            THE SAURASHTRA COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE SEVA VIKAS COOPERATIVE BANK LIMITED">
                            THE SEVA VIKAS COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE SEVALIA URBAN COOPERATIVE BANK LIMITED">
                            THE SEVALIA URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE SHAMRAO VITHAL COOPERATIVE BANK">
                            THE SHAMRAO VITHAL COOPERATIVE BANK
                          </option>
                          <option value="THE SHIRPUR PEOPLES COOPERATIVE BANK LIMITED ">
                            THE SHIRPUR PEOPLES COOPERATIVE BANK LIMITED{" "}
                          </option>
                          <option value="THE SIRSA CENTRAL COOPERATIVE  BANK LIMITED">
                            THE SIRSA CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE SIRSI URBAN SAHAKARI BANK LIMITED">
                            THE SIRSI URBAN SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE SITAMARHI CENTRAL COOPERATIVE BANK">
                            THE SITAMARHI CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="THE SOLAPUR DIST CENTRAL COOPERATIVE BANK">
                            THE SOLAPUR DIST CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="THE SOLAPUR DISTRICT CENTRAL COOPERATIVE BANK LIMI">
                            THE SOLAPUR DISTRICT CENTRAL COOPERATIVE BANK LIMI
                          </option>
                          <option value="THE SOUTH CANARA DISTRICT CENTRAL COOPERATIVE BANK">
                            THE SOUTH CANARA DISTRICT CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="THE SSK COOPERATIVE BANK LIMITED">
                            THE SSK COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE SURAT DISTRICT COOPERATIVE BANK LIMITED">
                            THE SURAT DISTRICT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE SURATH PEOPLES COOPERATIVE BANK LIMITED">
                            THE SURATH PEOPLES COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE TAMIL NADU STATE APEX COOPERATIVE BANK">
                            THE TAMIL NADU STATE APEX COOPERATIVE BANK
                          </option>
                          <option value="THE TARN TARAN CENTRAL COOPERATIVE BANK LIMITED">
                            THE TARN TARAN CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE TEXCO BANK ">
                            THE TEXCO BANK{" "}
                          </option>
                          <option value="THE THANE BHARAT SAHAKARI BANK LIMITED">
                            THE THANE BHARAT SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE THANJAVUR CENTRAL COOPERATIVE BANK LIMITED">
                            THE THANJAVUR CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE THOOTHUKUDI DISTRICT CENTRAL COOPERATIVE BANK ">
                            THE THOOTHUKUDI DISTRICT CENTRAL COOPERATIVE BANK{" "}
                          </option>
                          <option value="THE THRISSUR DISTRICT  COOPERATIVE BANK LIMITED">
                            THE THRISSUR DISTRICT COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE TIRUCHIRAPALLI DISTRICT CENTRAL COOPERATIVE BANK LTD">
                            THE TIRUCHIRAPALLI DISTRICT CENTRAL COOPERATIVE BANK
                            LTD
                          </option>
                          <option value="THE TIRUNELVELI DISTRICT CENTRAL COOPERATIVE BANK ">
                            THE TIRUNELVELI DISTRICT CENTRAL COOPERATIVE BANK{" "}
                          </option>
                          <option value="THE TIRUVALLA EAST COOPERATIVE BANK">
                            THE TIRUVALLA EAST COOPERATIVE BANK
                          </option>
                          <option value="THE TIRUVANNAMALAI DISTRICT CENTRAL COOPERATIVE BANK">
                            THE TIRUVANNAMALAI DISTRICT CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="THE TRICHUR URBAN CO OPERA BANK LIMITED">
                            THE TRICHUR URBAN CO OPERA BANK LIMITED
                          </option>
                          <option value="THE UDAIPUR URBAN COOPERATIVE BANK LIMITED">
                            THE UDAIPUR URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE UDUPI COOPERATIVE TOWN BANK">
                            THE UDUPI COOPERATIVE TOWN BANK
                          </option>
                          <option value="THE UNION COOPERATIVE BANK LIMITED">
                            THE UNION COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE URBAN COOPERATIVE BANK LIMITED">
                            THE URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE UTTARSANDA PEOPLES COOPERATIVE BANK">
                            THE UTTARSANDA PEOPLES COOPERATIVE BANK
                          </option>
                          <option value="THE VAISHALI DISTRICT CENTRAL COOPERATIVE BANK LIM">
                            THE VAISHALI DISTRICT CENTRAL COOPERATIVE BANK LIM
                          </option>
                          <option value="THE VARACHHA COOPERATIVE BANK LIMITED">
                            THE VARACHHA COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE VELLORE DISTRICT CENTRAL COOPERATIVE BANK LIMITED">
                            THE VELLORE DISTRICT CENTRAL COOPERATIVE BANK
                            LIMITED
                          </option>
                          <option value="THE VERAVAL MERCANTILE COOPERATIVE BANK LIMITED">
                            THE VERAVAL MERCANTILE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE VIJAPUR NAGARIK SAHAKARI BANK LIMITED">
                            THE VIJAPUR NAGARIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE VIJAY COOPERATIVE BANK LIMITED">
                            THE VIJAY COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE VILLUPURAM DISTRICT CENTRAL COOPERATIVE BANK LIMITED">
                            THE VILLUPURAM DISTRICT CENTRAL COOPERATIVE BANK
                            LIMITED
                          </option>
                          <option value="THE VIRUDHUNAGAR DISTRICT CENTRAL COOPERATIVE BANK">
                            THE VIRUDHUNAGAR DISTRICT CENTRAL COOPERATIVE BANK
                          </option>
                          <option value="THE VISAKHAPATNAM COOPERATIVE BANK LIMITED">
                            THE VISAKHAPATNAM COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE VISHWESHWAR SAHAKARI BANK LIMITED">
                            THE VISHWESHWAR SAHAKARI BANK LIMITED
                          </option>
                          <option value="THE WASHIM URBAN COOPERATIVE BANK LIMITED">
                            THE WASHIM URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE WEST BENGAL STATE COOPERATIVE BANK">
                            THE WEST BENGAL STATE COOPERATIVE BANK
                          </option>
                          <option value="THE YAMUNA NAGAR CENTRAL CO  OPERATIVE BANK LIMITE">
                            THE YAMUNA NAGAR CENTRAL CO OPERATIVE BANK LIMITE
                          </option>
                          <option value="THE YAVATMAL DCC BANK ">
                            THE YAVATMAL DCC BANK{" "}
                          </option>
                          <option value="THE YAVATMAL URBAN COOPERATIVE BANK LIMITED">
                            THE YAVATMAL URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="THE ZOROASTRIAN COOPERATIVE BANK LIMITED">
                            THE ZOROASTRIAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="TIRUPATI URBAN COOPERATIVE BANK LIMITED">
                            TIRUPATI URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="TJSB SAHAKARI BANK LIMITED">
                            TJSB SAHAKARI BANK LIMITED
                          </option>
                          <option value="TRIPURA GRAMIN BANK">
                            TRIPURA GRAMIN BANK
                          </option>
                          <option value="TRIPURA STATE COOPERATIVE BANK LIMITED">
                            TRIPURA STATE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="UCO BANK">UCO BANK</option>
                          <option value="UDAIPUR MAHILA URBAN COOPERATIVE BANK LIMITED">
                            UDAIPUR MAHILA URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="UDHAM SINGH NAGAR DISTRICT COOPERATIVE BANK LIMITE">
                            UDHAM SINGH NAGAR DISTRICT COOPERATIVE BANK LIMITE
                          </option>
                          <option value="UDYAM VIKAS SAHAKARI BANK LIMITED">
                            UDYAM VIKAS SAHAKARI BANK LIMITED
                          </option>
                          <option value="Ujjivan Small Finance Bank Limited">
                            Ujjivan Small Finance Bank Limited
                          </option>
                          <option value="UJJIVAN SMALL FINANCE BANK LIMITED DHARMANAGAR">
                            UJJIVAN SMALL FINANCE BANK LIMITED DHARMANAGAR
                          </option>
                          <option value="UNION BANK OF INDIA">
                            UNION BANK OF INDIA
                          </option>
                          <option value="UNION BANK OF INDIA CREDIT CARD">
                            UNION BANK OF INDIA CREDIT CARD
                          </option>
                          <option value="UNITED BANK OF INDIA, LANGPI DEHANGI RURAL BANK, D">
                            UNITED BANK OF INDIA, LANGPI DEHANGI RURAL BANK, D
                          </option>
                          <option value="UNITED OVERSEAS BANK LIMITED">
                            UNITED OVERSEAS BANK LIMITED
                          </option>
                          <option value="UNITED PURI NIMAPRA CENTRAL COOPERATIVE BANK ">
                            UNITED PURI NIMAPRA CENTRAL COOPERATIVE BANK{" "}
                          </option>
                          <option value="UNJHA NAGARIK SAHAKARI BANK LIMITED">
                            UNJHA NAGARIK SAHAKARI BANK LIMITED
                          </option>
                          <option value="URBAN COOPERATIVE BANK LIMITED">
                            URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="UTKAL GRAMYA BANK">
                            UTKAL GRAMYA BANK
                          </option>
                          <option value="UTKARSH SMALL FINANCE BANK">
                            UTKARSH SMALL FINANCE BANK
                          </option>
                          <option value="UTTAR BANGA KSHETRIYA GRAMIN BANK">
                            UTTAR BANGA KSHETRIYA GRAMIN BANK
                          </option>
                          <option value="UTTAR BIHAR GRAMIN BANK">
                            UTTAR BIHAR GRAMIN BANK
                          </option>
                          <option value="UTTAR PRADESH STATE COOPERATIVE BANK LIMITED">
                            UTTAR PRADESH STATE COOPERATIVE BANK LIMITED
                          </option>
                          <option value="UTTARAKHAND GRAMIN BANK">
                            UTTARAKHAND GRAMIN BANK
                          </option>
                          <option value="UTTARANCHAL GRAMIN BANK">
                            UTTARANCHAL GRAMIN BANK
                          </option>
                          <option value="UTTRAKHAND COOPERATIVE BANK LIMITED">
                            UTTRAKHAND COOPERATIVE BANK LIMITED
                          </option>
                          <option value="UTTRAKHAND STATE CO-COPERATIVE BANK LIMITED">
                            UTTRAKHAND STATE CO-COPERATIVE BANK LIMITED
                          </option>
                          <option value="V.V.C.C BANK LIMITED">
                            V.V.C.C BANK LIMITED
                          </option>
                          <option value="VAISH COOPERATIVE ADARSH BANK ">
                            VAISH COOPERATIVE ADARSH BANK{" "}
                          </option>
                          <option value="VAISHYA NAGARI SAHAKARI BANK LIMITED">
                            VAISHYA NAGARI SAHAKARI BANK LIMITED
                          </option>
                          <option value="VALMIKI URBAN COOPERATIVE BANK LIMITED">
                            VALMIKI URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="VALSAD DISRICT CENTRAL COOPERATIVE BANK LIMITED">
                            VALSAD DISRICT CENTRAL COOPERATIVE BANK LIMITED
                          </option>
                          <option value="VANANCHAL GRAMIN BANK">
                            VANANCHAL GRAMIN BANK
                          </option>
                          <option value="VASAI JANATA SAHAKARI BANK LIMITED">
                            VASAI JANATA SAHAKARI BANK LIMITED
                          </option>
                          <option value="VASAI VIKAS SAHAKARI BANK LIMITED">
                            VASAI VIKAS SAHAKARI BANK LIMITED
                          </option>
                          <option value="VIDHARBHA KONKAN GRAMIN BANK LIMITED">
                            VIDHARBHA KONKAN GRAMIN BANK LIMITED
                          </option>
                          <option value="VIKAS SOUHARDA COOPERATIVE BANK LIMITED">
                            VIKAS SOUHARDA COOPERATIVE BANK LIMITED
                          </option>
                          <option value="VIKRAMADITYA NAGRIK SAHAKARI BANK">
                            VIKRAMADITYA NAGRIK SAHAKARI BANK
                          </option>
                          <option value="VISHWAS COOPERATIVE BANK LIMITED">
                            VISHWAS COOPERATIVE BANK LIMITED
                          </option>
                          <option value="VYAVSAYIK SAHAKARI BANK ">
                            VYAVSAYIK SAHAKARI BANK{" "}
                          </option>
                          <option value="WARDHMAN URBAN COOPERATIVE BANK LIMITED">
                            WARDHMAN URBAN COOPERATIVE BANK LIMITED
                          </option>
                          <option value="YADAGIRI LNS COOPERATIVE BANK ">
                            YADAGIRI LNS COOPERATIVE BANK{" "}
                          </option>
                          <option value="YES BANK">YES BANK</option>
                          <option value="ZILA SAHAKARI BANK LIMITED">
                            ZILA SAHAKARI BANK LIMITED
                          </option>
                          <option value="Zila Sahkari Bank Ltd  Bulandshahr">
                            Zila Sahkari Bank Ltd Bulandshahr
                          </option>
                          <option value="ZILA SAHKARI BANK LTD GHAZIABAD">
                            ZILA SAHKARI BANK LTD GHAZIABAD
                          </option>
                          <option value="ZILA SAHKARI BANK LTD MUZAFFARNAGAR">
                            ZILA SAHKARI BANK LTD MUZAFFARNAGAR
                          </option>
                        </select>
                        <span
                          className="select2 select2-container select2-container--default"
                          dir="ltr"
                          data-select2-id="select2-data-1-z9gj"
                          style={{ width: 385 }}
                        >
                          <span className="selection">
                            <span
                              className="select2-selection select2-selection--single"
                              role="combobox"
                              aria-haspopup="true"
                              aria-expanded="false"
                              tabIndex={0}
                              aria-disabled="false"
                              aria-labelledby="select2-bank_name-container"
                              aria-controls="select2-bank_name-container"
                            >
                              <span
                                className="select2-selection__rendered"
                                id="select2-bank_name-container"
                                role="textbox"
                                aria-readonly="true"
                                title="A B BANK LIMITED"
                              >
                                A B BANK LIMITED
                              </span>
                              <span
                                className="select2-selection__arrow"
                                role="presentation"
                              >
                                <b role="presentation" />
                              </span>
                            </span>
                          </span>
                          <span
                            className="dropdown-wrapper"
                            aria-hidden="true"
                          />
                        </span>
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="form-group">
                        <label htmlFor="email-id-vertical">
                          Account Number
                        </label>
                        <input
                          type="text"
                          id="account_number"
                          className="form-control"
                          placeholder="Account Number"
                        />
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="form-group">
                        <label htmlFor="email-id-vertical">IFSC Code</label>
                        <div className="input-group">
                          <input
                            type="text"
                            id="ifsc_code"
                            className="form-control"
                            placeholder="IFSC Code"
                          />
                          <div className="input-group-append">
                            <button
                              className="btn btn-primary"
                              type="button"
                              id="button-addon2"
                              onclick="get_ifsc()"
                            >
                              Get Ifsc
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="form-group">
                        <label htmlFor="email-id-vertical">Bene Name</label>
                        <div className="input-group">
                          <input
                            type="text"
                            id="name"
                            className="form-control"
                            placeholder="Bene Name"
                          />
                          <div className="input-group-append">
                            <button
                              className="btn btn-primary"
                              type="button"
                              id="button-addon2"
                              onclick="account_verifivation()"
                            >
                              Name Verify
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <button
                        id="btn-confirm"
                        className="btn btn-primary btn-sm tx-13 mr-1 mb-1 waves-effect waves-light right"
                        onclick="add_bene()"
                      >
                        Add Beneficiary
                      </button>
                    </div>
                  </div>
                  {/*end add beneficiary*/}
                  <div
                    className="form-body"
                    id="payout-transfer-box"
                    style={{}}
                  >
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="email-id-vertical">Bank Name</label>
                        <input
                          type="text"
                          id="payout_bank_name"
                          className="form-control"
                          disabled=""
                        />
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="form-group">
                        <label htmlFor="email-id-vertical">Mobile Number</label>
                        <input
                          type="text"
                          id="payout_mobile"
                          className="form-control"
                          disabled=""
                        />
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="form-group">
                        <label htmlFor="email-id-vertical">
                          Account Number
                        </label>
                        <input
                          type="text"
                          id="payout_account_number"
                          className="form-control"
                          disabled=""
                        />
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="form-group">
                        <label htmlFor="email-id-vertical">Name</label>
                        <input
                          type="text"
                          id="payout_name"
                          className="form-control"
                          disabled=""
                        />
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="form-group">
                        <label htmlFor="email-id-vertical">IFSC Code</label>
                        <input
                          type="text"
                          id="payout_ifsc_code"
                          className="form-control"
                          disabled=""
                        />
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="form-group">
                        <label htmlFor="email-id-vertical">Amount</label>
                        <input
                          type="text"
                          id="payout_amount"
                          className="form-control"
                          placeholder="Enter Amount"
                        />
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="form-group">
                        <label htmlFor="email-id-vertical">MPin</label>
                        <input
                          type="password"
                          id="pin"
                          className="form-control"
                          placeholder="Transaction Pin"
                        />
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <button
                        id="btn-confirm"
                        className="btn btn-primary btn-sm tx-13 mr-1 mb-1 waves-effect waves-light right"
                        onclick="payout_trasnfer()"
                      >
                        Payout Transfer
                      </button>
                    </div>
                  </div>
                  <div
                    className="form-body"
                    id="wallet-transfer-box"
                    style={{ display: "none" }}
                  >
                    <div className="col-12 mt-2">
                      <div className="form-group">
                        <label htmlFor="email-id-vertical">Amount</label>
                        <input
                          type="text"
                          id="wallet_amount"
                          className="form-control"
                          placeholder="Enter Amount"
                        />
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="form-group">
                        <label htmlFor="email-id-vertical">MPin</label>
                        <input
                          type="password"
                          id="wallet_pin"
                          className="form-control"
                          placeholder="Transaction Pin"
                        />
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <button
                        id="btn-confirm"
                        className="btn btn-primary btn-sm tx-13 mr-1 mb-1 waves-effect waves-light right"
                        onclick="to_wallet_trasnfer()"
                      >
                        Wallet Transfer
                      </button>
                    </div>
                  </div>
                  {/*payout trasnfer*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    
   
    <div className="position-fixed bottom-0 end-0 m-3 z-index-5">
      {/*<button class="btn btn-square btn-theme shadow" type="button" data-bs-toggle="offcanvas" data-bs-target="#theming" aria-controls="theming"><i class="bi bi-palette"></i></button>*/}
      <br />
      <button
        className="btn btn-theme btn-square rounded-circle shadow mt-2 d-none"
        id="backtotop"
      >
        <i className="bi bi-arrow-up" />
      </button>
    </div>
    <div
      className="offcanvas offcanvas-end shadow border-0"
      tabIndex={-1}
      id="theming"
      data-bs-scroll="true"
      data-bs-backdrop="false"
      aria-labelledby="theminglabel"
    >
      <div className="offcanvas-header border-bottom">
        <div>
          <h5 className="offcanvas-title" id="theminglabel">
            Personalize
          </h5>
          <p className="text-secondary small">Make it more like your own</p>
        </div>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
      </div>
      <div className="offcanvas-body">
        <h6 className="offcanvas-title">Colors</h6>
        <p className="text-secondary small mb-4">Change colors of templates</p>
        <div className="row mb-4 theme-select">
          <div className="col-auto">
            <div className="select-box text-center mb-2" data-title="">
              <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                <i className="bi bi-arrow-clockwise" />
              </span>
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-blue"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-blue" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-indigo"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-indigo" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-purple"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-purple" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-pink"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-pink" />
            </div>
          </div>
          <div className="col-auto">
            <div className="select-box text-center mb-2" data-title="theme-red">
              <span className="avatar avatar-40 rounded-circle mb-2 bg-red" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-orange"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-orange" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-yellow"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-yellow" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-green"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-green" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-teal"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-teal" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-cyan"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-cyan" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-grey"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-grey" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-brown"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-brown" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-chocolate"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-chocolate" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="theme-black"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-dark" />
            </div>
          </div>
        </div>
        <h6 className="offcanvas-title">Backgrounds</h6>
        <p className="text-secondary small mb-4">Change color for background</p>
        <div className="row mb-4 theme-background">
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-default"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                <i className="bi bi-arrow-clockwise" />
              </span>
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-white"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-white" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-r-gradient"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-r-gradient" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-1"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-1" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-2"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-2" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-3"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-3" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-4"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-4" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-5"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-5" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-6"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-6" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-7"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-7" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-8"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-8" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-9"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-9" />
            </div>
          </div>
          <div className="col-auto">
            <div
              className="gradient-box text-center mb-2"
              data-title="bg-gradient-10"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-gradient-10" />
            </div>
          </div>
        </div>
        <h6 className="offcanvas-title">Sidebar Layout</h6>
        <p className="text-secondary small mb-4">Change sidebar layout style</p>
        <div className="row mb-4 sidebar-layout">
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="adminuiux-sidebar-standard"
              data-bs-toggle="tooltip"
              aria-label="None"
              data-bs-original-title="None"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                <i className="bi bi-arrow-clockwise" />
              </span>
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="adminuiux-sidebar-iconic"
              data-bs-toggle="tooltip"
              aria-label="Iconic"
              data-bs-original-title="Iconic"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                <i className="bi bi-bezier h4" />
              </span>
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="adminuiux-sidebar-boxed"
              data-bs-toggle="tooltip"
              aria-label="Boxed"
              data-bs-original-title="Boxed"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                <i className="bi bi-box h5" />
              </span>
            </div>
          </div>
          <div className="col-auto">
            <div
              className="select-box text-center mb-2"
              data-title="adminuiux-sidebar-boxed adminuiux-sidebar-iconic"
              data-bs-toggle="tooltip"
              aria-label="Iconic+Boxed"
              data-bs-original-title="Iconic+Boxed"
            >
              <span className="avatar avatar-40 rounded-circle mb-2 bg-default">
                <i className="bi bi-bounding-box h5" />
              </span>
            </div>
          </div>
        </div>
        <div className="text-center mb-4">
          <a
            href="investment-personalization.html"
            className="btn btn-sm btn-outline-theme"
          >
            More options <i className="bi bi-arrow-right-short" />
          </a>
        </div>
      </div>
    </div>
  </div>
</main>
      </div>
    </>
  );
}